import type { Language } from "@/i18n/translations";

type FeatureTranslations = Record<Language, Record<string, string>>;

export const featureTranslations: FeatureTranslations = {
  pt: {
    "common.close": "Fechar",
    "common.retry": "Tentar novamente",
    "common.error": "Erro",
    "review.pending.title": "A preparar revisao final",
    "review.pending.description": "Os totais e validacoes finais ainda estao a ser calculados. Aguarde um instante antes de guardar o orcamento.",
    "common.optional": "Opcional",
    "common.country": "Pais",
    "common.region": "Regiao",
    "common.type": "Tipo",
    "common.name": "Nome",
    "common.value": "Valor",
    "common.year": "Ano",
    "common.month": "Mes",
    "nav.section.management": "Gestao",
    "nav.section.commercial": "Comercial",
    "nav.section.bim": "BIM",
    "nav.section.execution": "Execucao",
    "nav.section.directory": "Diretorio",
    "nav.dashboard": "Painel",
    "nav.analytics": "Análises",
    "nav.budgets": "Orcamentos",
    "nav.templates": "Modelos",
    "nav.documents": "Documentos",
    "nav.revitImport": "Importar Revit",
    "nav.works": "Obras",
    "nav.measurementAutos": "Autos de Medicao",
    "nav.costDatabase": "Base de custos",
    "nav.contacts": "Contactos",
    "nav.settings": "Definicoes",
    "nav.help": "Ajuda",
    "nav.newBudget": "Novo orcamento",
    "costDatabase.eyebrow": "Diretorio tecnico",
    "costDatabase.title": "Base de Custos",
    "costDatabase.description": "Catalogo operacional de insumos, composicoes e fontes. Esta e a area onde entram Excel, CSV e BC3 antes de serem usados no editor ou no IFC.",
    "costDatabase.priceIntelligence": "Inteligencia de precos",
    "costDatabase.priceIntelligenceTitle": "Use para analisar historico, variacao e confiabilidade de precos ja importados ou registados.",
    "costDatabase.card.import.title": "Importacao",
    "costDatabase.card.import.desc": "Excel, CSV e BC3 alimentam a mesma biblioteca de recursos e composicoes.",
    "costDatabase.card.compositions.title": "Composicoes",
    "costDatabase.card.compositions.desc": "Cada composicao fica pronta para ser associada a partidas, capitulos e elementos IFC.",
    "costDatabase.card.traceability.title": "Rastreabilidade",
    "costDatabase.card.traceability.desc": "Fontes e datas de referencia tornam o preco defensavel em propostas reais.",
    "costDatabase.tab.resources": "Recursos",
    "costDatabase.tab.compositions": "Composicoes",
    "costDatabase.tab.sources": "Fontes",
    "costDatabase.tab.imports": "Importacoes",
    "costDatabase.tab.indices": "Indices",
    "costDatabase.action.importExcel": "Importar Excel",
    "costDatabase.action.importBC3": "Importar BC3",
    "costDatabase.resources.title": "Recursos",
    "costDatabase.resources.desc": "Catalogo de materiais, mao de obra e equipamentos com precos unitarios.",
    "costDatabase.compositions.title": "Composicoes de Custo",
    "costDatabase.compositions.desc": "Agrupamentos de insumos que definem o custo unitario de um trabalho. Expanda cada composicao para gerir os recursos que a compoem.",
    "costDatabase.sources.title": "Fontes de Preco",
    "costDatabase.sources.desc": "Rastreie a origem e fiabilidade dos precos: fornecedores, tabelas publicas, historico de obra.",
    "costDatabase.imports.xlsxNoteTitle": "Deteccao automatica XLSX:",
    "costDatabase.imports.xlsxNoteDesc": "o parser procura cabecalhos comuns em PT/ES/EN como codigo, descricao, unidade e preco. Ficheiros fora desse padrao entram em staging para revisao, nao sao aprovados automaticamente.",
    "costDatabase.imports.bc3NoteTitle": "BC3/FIEBDC:",
    "costDatabase.imports.bc3NoteDesc": "a V1 le conceitos e relacoes basicas de ficheiros FIEBDC-3. Registos de dialectos especificos ficam como avisos para normalizacao posterior.",
    "costDatabase.indices.title": "Indices e atualizacao",
    "costDatabase.indices.desc": "Atualize precos historicos por indices cadastrados manualmente ou por CSV.",
    "priceSource.countSingular": "fonte de preco",
    "priceSource.countPlural": "fontes de preco",
    "priceSource.new": "Nova fonte",
    "priceSource.created": "Fonte criada",
    "priceSource.deleted": "Fonte eliminada",
    "priceSource.deleteConfirm": "Eliminar fonte \"{name}\"?",
    "priceSource.deleteTitle": "Eliminar fonte de preco?",
    "priceSource.deleteDescription": "A fonte \"{name}\" sera removida da base de custos. Esta acao nao pode ser desfeita.",
    "costDatabase.resource.deleteTitle": "Eliminar recurso?",
    "costDatabase.resource.deleteDescription": "O recurso \"{name}\" sera removido da base de custos. Esta acao nao pode ser desfeita.",
    "costDatabase.resource.deleted": "Recurso eliminado",
    "costDatabase.resource.inUseError": "Recurso em uso - remova das composicoes primeiro",
    "costDatabase.composition.deleteTitle": "Eliminar composicao?",
    "costDatabase.composition.deleteDescription": "A composicao \"{name}\" sera removida da base de custos. Esta acao nao pode ser desfeita.",
    "costDatabase.composition.deleted": "Composicao eliminada",
    "costDatabase.compositionItem.removeTitle": "Remover recurso da composicao?",
    "costDatabase.compositionItem.removeDescription": "Este recurso sera removido da composicao. Esta acao nao pode ser desfeita.",
    "priceSource.empty": "Registe as origens dos precos: fornecedores, tabelas publicas, historico interno...",
    "priceSource.dialogTitle": "Nova fonte de preco",
    "priceSource.namePlaceholder": "LNEC 2024, Fornecedor X...",
    "priceSource.reliability": "Fiabilidade",
    "priceSource.referenceDate": "Data de referencia",
    "priceSource.create": "Criar fonte",
    "priceSource.type.manual": "Manual",
    "priceSource.type.supplier": "Fornecedor",
    "priceSource.type.internal_history": "Historico interno",
    "priceSource.type.public_table": "Tabela publica",
    "priceSource.type.csv_import": "Importacao CSV",
    "priceSource.type.estimate": "Estimativa",
    "priceSource.reliability.high": "Alta",
    "priceSource.reliability.medium": "Media",
    "priceSource.reliability.low": "Baixa",
    "priceSource.reliability.unknown": "Desconhecida",
    "costIndex.sourceType.official_index": "Indice oficial",
    "costIndex.sourceType.inflation_index": "Inflacao",
    "costIndex.sourceType.construction_cost_index": "Custo de construcao",
    "costIndex.sourceType.manual_index": "Manual",
    "costIndex.family.labor": "Mao de obra",
    "costIndex.family.material": "Materiais",
    "costIndex.family.equipment": "Equipamento",
    "costIndex.family.energy": "Energia",
    "costIndex.family.transport": "Transporte",
    "costIndex.family.total_construction": "Construcao total",
    "costIndex.family.steel": "Aco",
    "costIndex.family.cement": "Cimento",
    "costIndex.family.concrete": "Betao / concreto",
    "costIndex.family.timber": "Madeira",
    "costIndex.family.fuel": "Combustivel",
    "costIndex.family.other": "Outro",
    "costIndex.sources.title": "Fontes de indices",
    "costIndex.sources.desc": "Registe fontes manuais ou oficiais sem ligar a buscas automaticas.",
    "costIndex.sourceNamePlaceholder": "INE, INE ES, fonte interna...",
    "costIndex.publisher": "Publicador",
    "costIndex.monthly.title": "Indice mensal",
    "costIndex.monthly.desc": "Cadastre valores base e alvo por familia de custo.",
    "costIndex.source": "Fonte",
    "costIndex.selectSource": "Selecionar fonte",
    "costIndex.family": "Familia",
    "costIndex.basePeriod": "Periodo base",
    "costIndex.basePeriodPlaceholder": "ex: 2020=100",
    "costIndex.saveIndex": "Guardar indice",
    "costIndex.importCsv": "Importar CSV",
    "costIndex.run.title": "Executar atualizacao empirica",
    "costIndex.run.desc": "Gera estimativas em tabela propria. Nao altera observacoes, orcamentos nem PDFs.",
    "costIndex.targetYear": "Ano alvo",
    "costIndex.targetMonth": "Mes alvo",
    "costIndex.mode": "Modo",
    "costIndex.mode.dry": "Simular",
    "costIndex.mode.real": "Criar estimativas",
    "costIndex.runAdjustment": "Executar ajuste",
    "costIndex.registeredSources": "Fontes cadastradas",
    "costIndex.previousRuns": "Runs anteriores",
    "costIndex.recentIndices": "Indices recentes",
    "costIndex.empty.sources": "Ainda nao existem fontes de indices.",
    "costIndex.empty.runs": "Ainda nao existem execucoes.",
    "costIndex.empty.indices": "Ainda nao existem indices mensais.",
    "costIndex.adjustedLine": "{adjusted}/{processed} ajustados. Falhas: {failed}.",
    "costIndex.summary.simulation": "Resumo da simulacao",
    "costIndex.summary.execution": "Resumo da execucao",
    "costIndex.summaryLine": "{adjusted} ajustados, {alreadyExists} ja existentes, {failed} falhados, {processed} processados.",
    "costIndex.toast.sourceCreated": "Fonte de indice criada",
    "costIndex.toast.indexCreated": "Indice mensal criado",
    "costIndex.toast.indicesImported": "Indices importados",
    "costIndex.toast.rowsLoaded": "{count} linhas carregadas.",
    "costIndex.toast.simulationDone": "Simulacao concluida",
    "costIndex.toast.updateDone": "Atualizacao concluida",
    "costIndex.toast.localSimulation": "{summary} Edge Function indisponivel; foi usada simulacao local.",
    "costIndex.error.createSource": "Nao foi possivel criar a fonte.",
    "costIndex.error.createIndex": "Nao foi possivel criar o indice.",
    "costIndex.error.importCsv": "Nao foi possivel importar o CSV.",
    "costIndex.error.runAdjustment": "Nao foi possivel executar o ajuste.",
    "costIndex.error.emptyCsv": "CSV sem linhas validas. Use cabecalhos: index_family,period_year,period_month,index_value.",
    "costIndex.error.estimatesNeedEdgeFunction": "A criacao de estimativas requer a Edge Function cost-adjust-prices.",
    "dashboard.duplicate.action": "Duplicar",
    "dashboard.duplicate.suffix": "(cópia)",
    "dashboard.duplicate.createdTitle": "Orçamento duplicado",
    "dashboard.duplicate.createdDescription": "Foi criada uma nova cópia em rascunho.",
    "dashboard.list.actions": "Ações do orçamento",
    "dashboard.empty.title": "Comece com o primeiro orçamento técnico",
    "dashboard.empty.description":
      "Configure a empresa, crie o primeiro orçamento e prepare a base para PDFs, medições, autos e análise técnica.",
    "dashboard.empty.settings": "Configurar empresa",
    "dashboard.empty.newBudget": "Criar primeiro orçamento",
    "dashboard.empty.noBudgetsTitle": "Sem orçamentos ainda",
    "dashboard.empty.noBudgetsDescription":
      "Comece pelo orçamento técnico ou prepare primeiro a empresa, a base de custos e os ficheiros BIM/IFC. Estes passos ajudam a gerar documentos mais claros e rastreáveis.",
    "dashboard.empty.reviewPlan": "Ver limites do plano",
    "dashboard.empty.settingsDescription": "Dados comerciais para PDFs e documentos.",
    "dashboard.empty.ifcTitle": "Importar BIM/IFC",
    "dashboard.empty.ifcDescription": "Preparar ficheiros e mapeamentos técnicos.",
    "dashboard.empty.costDatabaseTitle": "Base de custos",
    "dashboard.empty.costDatabaseDescription": "Organizar recursos e composições reutilizáveis.",
    "dashboard.deleteDialog.title": "Eliminar orcamento?",
    "dashboard.deleteDialog.description": "Esta acao nao pode ser desfeita.",
    "dashboard.deleteBlocked.title": "Nao e possivel eliminar este orcamento",
    "dashboard.deleteBlocked.description": "Orcamentos enviados ou aprovados nao podem ser eliminados.",
    "dashboard.deleted": "Orcamento eliminado",
    "ifcImport.compareDialog.title": "Comparar com o modelo anterior?",
    "ifcImport.compareDialog.description": "Este orcamento ja tem um modelo IFC associado. Pode comparar o novo modelo com a versao anterior antes de concluir a revisao BIM.",
    "ifcImport.compareDialog.skip": "Continuar sem comparar",
    "ifcImport.compareDialog.confirm": "Comparar modelos",
    "ifcImport.compareGenerated": "Comparacao IFC gerada",
    "dashboard.cockpit.eyebrow": "Painel operacional",
    "dashboard.painel.title": "Visão geral",
    "dashboard.cockpit.title": "Organize orçamentos, documentos e próximos passos",
    "dashboard.cockpit.description":
      "Uma visão rápida para equipas de engenharia acompanharem propostas, versões e capacidade comercial.",
    "dashboard.cockpit.portfolio": "Orçamentos",
    "dashboard.next.budget": "Próximo orçamento",
    "dashboard.next.blocked": "Rever limite do plano",
    "dashboard.next.ready": "Pronto para criar",
    "dashboard.next.status": "Conta",
    "dashboard.next.company": "Acesso",
    "dashboard.next.admin": "Administração ativa",
    "dashboard.next.member": "Operação de membro",
    "dashboard.attention.eyebrow": "Atenção necessária",
    "dashboard.attention.title": "Próximos passos",
    "dashboard.attention.clear": "Sem ações críticas",
    "dashboard.attention.clearDescription": "A operação está pronta para continuar com novos orçamentos e acompanhamento comercial.",
    "dashboard.attention.companyTitle": "Completar identidade da empresa",
    "dashboard.attention.companyDescription": "Preencha dados comerciais antes de enviar propostas reais.",
    "dashboard.attention.draftsTitle": "Rascunhos por concluir",
    "dashboard.attention.draftsDescription": "orçamentos ainda precisam de revisão antes do envio.",
    "dashboard.attention.sentTitle": "Propostas enviadas",
    "dashboard.attention.sentDescription": "orçamentos aguardam acompanhamento comercial.",
    "dashboard.attention.limitTitle": "Capacidade do plano atingida",
    "dashboard.attention.invitesTitle": "Convites pendentes",
    "dashboard.attention.invitesDescription": "convites aguardam aceitação.",
    "dashboard.attention.viewDrafts": "Ver rascunhos",
    "dashboard.attention.viewSent": "Ver enviados",
    "dashboard.attention.manageTeam": "Gerir equipa",
    "dashboard.summary.loading": "A carregar resumo do painel",
    "dashboard.summary.activeBudgets": "Orçamentos ativos",
    "dashboard.summary.totalSuffix": "no total",
    "dashboard.summary.readyToExport": "Prontos para exportar",
    "dashboard.summary.approvedBudgets": "Orçamentos aprovados",
    "dashboard.summary.noneApproved": "Nenhum aprovado ainda",
    "dashboard.summary.needsAction": "Ação necessária",
    "dashboard.summary.draftsOrSent": "Rascunhos ou enviados",
    "dashboard.summary.costDatabase": "Base de Preços",
    "dashboard.summary.compositionAbbrev": "comp.",
    "dashboard.summary.resourcesSuffix": "insumos",
    "dashboard.summary.latestTotal": "Último total",
    "dashboard.summary.latestCalculation": "Do último cálculo",
    "identification.clientName": "Cliente",
    "identification.clientNamePlaceholder": "Nome do cliente ou entidade",
    "settings.adminOnly": "Apenas administradores podem alterar as definições da empresa.",
    "settings.adminOnlyHint":
      "Estas definições afetam documentos comerciais. Peça a um administrador para as alterar.",
    "settings.section.admin.eyebrow": "Administração",
    "settings.section.admin.title": "Plano, equipa e controlo",
    "settings.section.admin.description":
      "Gerir acesso, limites comerciais e sinais de confiança da organização.",
    "settings.section.company.eyebrow": "Identidade comercial",
    "settings.section.company.title": "Empresa e documentos",
    "settings.section.company.description":
      "Informação usada em propostas, PDF e materiais enviados ao cliente.",
    "wizard.editBudget": "Editar orçamento",
    "wizard.updated": "Orçamento atualizado",
    "dashboard.version.createdTitle": "Nova versão criada",
    "dashboard.version.createdDescriptionSuffix": "disponível no histórico.",
    "dashboard.version.new": "Nova versão",
    "dashboard.version.history": "Histórico de versões",
    "dashboard.version.singular": "versão",
    "dashboard.version.plural": "versões",
    "dashboard.version.fallbackBudgetName": "Orçamento",
    "dashboard.version.current": "versão atual",
    "dashboard.version.createdFrom": "criada a partir da",
    "dashboard.version.open": "Abrir",
    "dashboard.version.version": "Versão",
    "dashboard.version.baseCost": "Custo base",
    "dashboard.version.snapshotNote":
      "Snapshot preservado para futura comparação e exportação PDF por versão.",
    "dashboard.version.create": "Criar nova versão",
    "commerce.planTitle": "Plano e utilização",
    "commerce.planDescription": "Estado comercial da empresa e limites atuais da conta.",
    "commerce.plan.trialLabel": "Gratuito",
    "commerce.status.trial": "gratuito",
    "commerce.status.active": "ativo",
    "commerce.status.past_due": "pagamento pendente",
    "commerce.status.canceled": "cancelado",
    "commerce.providerReady": "Conta ligada a um fornecedor de faturação.",
    "commerce.providerPending": "A ativação do plano Business é feita pela equipa Orzio.",
    "commerce.contactSales": "Ativar Business",
    "commerce.upgradeCta": "Atualizar plano",
    "commerce.manageSubscription": "Gerir subscrição",
    "commerce.currentPlan": "Plano atual",
    "commerce.planSku.trial": "Trial",
    "commerce.planSku.budget_starter": "Budget Starter",
    "commerce.planSku.budget_pro": "Budget Pro",
    "commerce.planSku.budget_business": "Budget Business",
    "commerce.planSku.takeoff_pro": "Takeoff Pro",
    "commerce.planSku.takeoff_team": "Takeoff Team",
    "commerce.productFamily.budget": "Budget",
    "commerce.productFamily.takeoff": "Takeoff",
    "commerce.trialBannerTitle": "Período experimental ativo",
    "commerce.trialBannerDescription":
      "A sua organização está a testar o produto com os limites do plano experimental.",
    "commerce.trialEndsAt": "Fim do trial",
    "commerce.currentPeriodEndsAt": "Fim do período atual",
    "commerce.cancelAtPeriodEnd": "Cancelamento agendado no fim do período",
    "commerce.planUnavailableTitle": "Detalhes do plano indisponíveis",
    "commerce.planUnavailableDescription":
      "Ainda não foi possível carregar o estado de faturação desta organização.",
    "commerce.errorLoadingPlan": "Não foi possível atualizar o estado de faturação",
    "commerce.noCustomer": "Ainda não existe uma subscrição ativa para gerir.",
    "commerce.upgradePromptTitle": "Desbloqueie mais capacidade",
    "commerce.upgradePromptDescription":
      "Reveja o plano atual para aumentar limites, gerir faturação e desbloquear mais capacidade.",
    "commerce.checkoutSuccessTitle": "Subscrição ativada",
    "commerce.checkoutSuccessDescription": "Obrigado. O plano Business foi ativado e os limites já estão atualizados.",
    "commerce.checkoutCanceledTitle": "Checkout cancelado",
    "commerce.checkoutCanceledDescription": "Não foi cobrado qualquer valor. Pode tentar de novo quando quiser.",
    "commerce.reviewPlan": "Rever plano",
    "commerce.upgradeRequired": "Upgrade necessário",
    "commerce.upgrade.budgetLimit":
      "Atingiu o limite de orçamentos ativos do plano atual.",
    "commerce.upgrade.versionLimit":
      "Atingiu o limite de versões por orçamento do plano atual.",
    "commerce.upgrade.exportLimit":
      "Atingiu o limite mensal de exportações PDF do plano atual.",
    "commerce.upgrade.moduleRequired":
      "Este tipo de orçamento não está incluído no plano atual.",
    "commerce.enabledModules": "Módulos incluídos",
    "commerce.module.projects": "Orçamentos de projetos",
    "commerce.module.works": "Orçamentos de obras",
    "commerce.activeBudgets": "Orçamentos ativos",
    "commerce.members": "Membros",
    "commerce.exportsThisMonth": "Exportações este mês",
    "commerce.aiCredits": "Créditos IA este mês",
    "commerce.unlimited": "ilimitado",
    "commerce.planUsageHelp": "Os limites são aplicados por organização de acordo com o plano atual.",
    "commerce.blockedBudgetHelp": "O limite de orçamentos ativos foi atingido. Reative capacidade no plano antes de criar novos orçamentos.",
    "commerce.trialReady": "Plano gratuito",
    "commerce.businessReady": "Business ativo",
    "commerce.exportBlockedTitle": "Exportação bloqueada pelo plano",
    "team.title": "Equipa",
    "team.description": "Gerir acesso interno com convites preparados para envio durante o onboarding.",
    "team.adminOnly": "Apenas administradores podem gerir a equipa.",
    "team.invite": "Convidar",
    "team.inviteEmailLabel": "Email do convite",
    "team.inviteRoleLabel": "Função do convite",
    "team.memberRoleLabel": "Função do membro",
    "team.inviteEmailPlaceholder": "colega@empresa.pt",
    "team.inviteCreated": "Convite criado",
    "team.inviteProviderReady": "O convite ficou preparado. O envio por email pode ser ativado quando o provider estiver ligado.",
    "team.inviteEmailSent": "Email de convite enviado.",
    "team.inviteEmailPending": "Convite criado. O envio de email ainda não está configurado.",
    "team.inviteEmailFailed": "Convite criado, mas falhou o envio de email. Copie o link manualmente.",
    "team.memberLimitReached": "O limite de membros do plano atual foi atingido. Reveja o plano antes de convidar mais pessoas.",
    "team.roleUpdated": "Função atualizada",
    "team.memberRemoved": "Membro removido",
    "team.inviteRevoked": "Convite revogado",
    "team.members": "Membros",
    "team.noMembers": "Ainda não há outros membros nesta organização.",
    "team.pendingInvites": "Convites pendentes",
    "team.noPendingInvites": "Sem convites pendentes.",
    "team.inviteReference": "Referência segura",
    "team.invitePrepared": "Pronto para envio",
    "team.inviteAcceptanceReady": "Link de aceitação preparado",
    "team.copyInviteLink": "Copiar link",
    "team.inviteLinkCopied": "Link de convite copiado",
    "team.revoke": "Revogar",
    "team.remove": "Remover",
    "team.confirmRemoveTitle": "Remover membro?",
    "team.confirmRemoveDescription": "Este utilizador perderá acesso à organização. Pode voltar a ser convidado mais tarde.",
    "team.confirmRevokeTitle": "Revogar convite?",
    "team.confirmRevokeDescription": "Este convite pendente deixará de poder ser usado.",
    "team.confirmAction": "Confirmar",
    "team.permissions": "Permissões",
    "team.subaccessPermissions": "Permissões do subacesso",
    "team.subaccessPlanRequiredTitle": "Subacessos requerem um plano pago",
    "team.subaccessPlanRequiredDescription":
      "Atualize para o plano Business para convidar e gerir subacessos da sua organização. Os seus orçamentos e dados continuam acessíveis.",
    "activity.title": "Atividade recente",
    "activity.description": "Sinal rápido de ações críticas registadas para suporte e auditoria.",
    "activity.empty": "Ainda não há atividade crítica registada.",
    "activity.systemActor": "System",
    "team.role.member": "Membro",
    "team.role.admin": "Admin",
    "invite.title": "Aceitar convite",
    "invite.description": "Confirme o acesso para entrar na organização.",
    "invite.organizationFallback": "Organização convidante",
    "invite.accept": "Aceitar convite",
    "invite.acceptedTitle": "Convite aceite",
    "invite.acceptedDescription": "O acesso à organização foi confirmado com segurança.",
    "invite.acceptFailed": "Não foi possível aceitar o convite.",
    "invite.goDashboard": "Ir para o painel",
    "invite.invalidTitle": "Convite indisponível",
    "invite.invalidDescription": "Este convite não pode ser usado. Peça um novo convite ao administrador.",
    "invite.signInRequired": "Entre com o email convidado para aceitar este acesso.",
    "invite.signIn": "Entrar para aceitar",
    "invite.supportHint": "Se o acesso falhar, peça ao administrador para confirmar o email convidado, o estado do convite e a validade do link.",
    "invite.status.invalid": "O link não corresponde a um convite válido.",
    "invite.status.revoked": "Este convite foi revogado.",
    "invite.status.expired": "Este convite expirou.",
    "invite.status.accepted": "Este convite já foi aceite.",
    "invite.status.pending": "Este convite está pronto para aceitação.",
    "execution.open": "Execução e medição",
    "execution.backToDashboard": "Voltar ao painel",
    "execution.eyebrow": "Execução 4D e autos",
    "execution.title": "Execução e medição",
    "execution.subtitle": "Gerir plano de execução, medições de obra e autos preparados a partir do orçamento aprovado.",
    "execution.generatePlan": "Gerar plano de execução",
    "execution.refreshPlan": "Atualizar plano",
    "execution.planGenerated": "Plano preparado",
    "execution.tasksPrepared": "tarefas prontas para acompanhamento",
    "execution.tasks": "Tarefas",
    "execution.tasksHelper": "Itens operacionais ligados ao orçamento",
    "execution.inProgress": "Em curso",
    "execution.inProgressHelper": "Tarefas com progresso ativo",
    "execution.completed": "Concluídas",
    "execution.completedHelper": "Tarefas marcadas como completas",
    "execution.autos": "Autos",
    "execution.autosHelper": "Linhas preparadas para auto",
    "execution.emptyTitle": "Ainda não existe plano de execução",
    "execution.emptyDescription": "Gere a primeira estrutura operacional a partir dos itens reais deste orçamento.",
    "execution.plan": "Plano",
    "execution.measurements": "Medições",
    "execution.taskRegister": "Registo de tarefas",
    "execution.taskRegisterDescription": "Acompanhe fases, quantidades planeadas, estados e progresso.",
    "execution.phase": "Fase",
    "execution.task": "Tarefa",
    "execution.planned": "Planeado",
    "execution.status": "Estado",
    "execution.progress": "Progresso",
    "execution.progressPercentHint": "Introduza um valor entre 0 e 100%.",
    "execution.editTask": "Atualizar tarefa",
    "execution.editTaskDescription": "Editar apenas campos operacionais seguros nesta primeira versão.",
    "execution.plannedStart": "Início planeado",
    "execution.plannedEnd": "Fim planeado",
    "execution.actualStart": "Início real",
    "execution.actualEnd": "Fim real",
    "execution.notes": "Notas",
    "execution.saveTask": "Guardar tarefa",
    "execution.taskSaved": "Tarefa atualizada",
    "execution.selectTask": "Selecione uma tarefa para editar.",
    "execution.dependencies": "Dependências",
    "execution.dependenciesDescription": "Visibilidade preparada para ligações de planeamento e futuro timeline/Gantt.",
    "execution.dependenciesReady": "dependências registadas",
    "execution.dependenciesEmpty": "Ainda não há dependências registadas. A estrutura já está pronta para evoluir.",
    "execution.measurementEntry": "Entrada de medição",
    "execution.measurementEntryDescription": "Registe quantidades medidas por tarefa mantendo histórico auditável.",
    "execution.previous": "Anterior",
    "execution.remaining": "Por medir",
    "execution.current": "Atual",
    "execution.measurementCurrentHint": "Quantidade desta medicao. Sugestao restante:",
    "execution.measurementQuantityRequired": "Indique uma quantidade medida superior a zero.",
    "execution.measuredAt": "Data da medição",
    "execution.recordMeasurement": "Registar medição",
    "execution.measurementRecorded": "Medição registada",
    "execution.accumulated": "Acumulado",
    "execution.measurementHistory": "Histórico de medições",
    "execution.approvedMeasurements": "medições aprovadas",
    "execution.measurementsEmpty": "Ainda não há medições registadas para este orçamento.",
    "execution.value": "Valor",
    "execution.unlinkedItem": "Item sem ligação",
    "execution.autoWorkflow": "Auto de medição",
    "execution.autoWorkflowDescription": "Prepare um auto a partir de medi\u00e7\u00f5es aprovadas no per\u00edodo selecionado.",
    "execution.periodStart": "Início do período",
    "execution.periodEnd": "Fim do período",
    "execution.generateAuto": "Preparar auto",
    "execution.autoPrepared": "Auto preparado",
    "execution.lines": "linhas",
    "execution.futurePdf": "O auto fica estruturado para revisão interna. A renderização PDF formal pode ligar-se a esta estrutura numa etapa posterior.",
    "execution.noAutos": "Ainda não há autos preparados para este orçamento.",
    "execution.autoNoLines": "Este auto não tem linhas elegíveis. Aprove medições no período antes de gerar novamente.",
    "execution.statusUpdated": "Estado da medição atualizado",
    "execution.certificateStatusUpdated": "Estado do auto atualizado",
    "execution.certified": "Certificada",
    "execution.submitReview": "Enviar para revisão",
    "execution.approve": "Aprovar",
    "execution.reject": "Rejeitar",
    "execution.void": "Anular",
    "execution.exportAutoPdf": "Exportar PDF",
    "execution.pdfPrepared": "PDF preparado",
    "execution.pdfVoidedBlocked": "Autos anulados não podem ser renderizados.",
    "execution.popupBlocked": "Não foi possível abrir a janela de PDF. Autorize pop-ups para este site.",
    "execution.pdfLastRendered": "Último PDF",
    "execution.pdfNotRendered": "PDF ainda não renderizado",
    // ── Cost Database Import ───────────────────────────────────────────────────
    "execution.autoProfileLead": "O modelo do auto define o pais, idioma, fiscalidade e assinaturas usadas na pre-visualizacao e na exportacao PDF.",
    "execution.autoProfileTitle": "Modelo do auto",
    "execution.autoProfileDescription": "Escolha o perfil operacional antes de rever ou gerar o documento final.",
    "execution.autoProfileCountry": "Pais do modelo",
    "execution.autoProfileContractType": "Tipo de contrato",
    "execution.autoProfileLanguage": "Idioma",
    "execution.autoProfileFinancialTitle": "Campos financeiros",
    "execution.autoProfileTaxEnabled": "Ativar IVA",
    "execution.autoProfileTaxRate": "Taxa de IVA",
    "execution.autoProfileRetentionEnabled": "Ativar retencao",
    "execution.autoProfileRetentionRate": "Percentagem de retencao",
    "execution.autoProfileSignaturesTitle": "Assinaturas",
    "execution.autoProfileSignature.contractor": "Incluir assinatura do empreiteiro",
    "execution.autoProfileSignature.supervisor": "Incluir assinatura da fiscalizacao / direcao de obra",
    "execution.autoProfileSignature.owner": "Incluir assinatura do dono de obra",
    "execution.autoProfileLegalTitle": "Aviso operacional",
    "execution.autoProfileLegalDescription": "Este perfil e uma configuracao operacional configuravel do Orzio e nao substitui validacao juridica ou contratual.",
    "execution.autoProfileCountryFields": "Campos especificos do pais",
    "execution.autoProfileCountryFieldsEmpty": "Este perfil nao acrescenta campos operacionais especificos do pais.",
    "execution.autoProfilePreviewTitle": "Pre-visualizacao",
    "execution.autoProfilePreviewDescription": "A vista abaixo reflete imediatamente o modelo selecionado.",
    "execution.autoProfilePreviewFrameTitle": "Pre-visualizacao do auto de medicao",
    "execution.autoProfilePreviewEmpty": "Gere um auto para ativar a pre-visualizacao do PDF profissional.",
    "execution.autoProfileContract.private": "Privado",
    "execution.autoProfileContract.public": "Publico",
    "execution.autoProfileContract.internal": "Interno / revisao piloto",
    "execution.autoProfileLanguageOption.pt": "Portugues",
    "execution.autoProfileLanguageOption.en": "Ingles",
    "execution.autoProfileLanguageOption.es": "Espanhol",
    "execution.autoProfileLanguageOption.fr": "Frances",
    "execution.autoProfileCountryOption.PT": "Portugal",
    "execution.autoProfileCountryOption.ES": "Espanha",
    "execution.autoProfileCountryOption.FR": "Franca",
    "execution.autoProfileCountryOption.DE": "Alemanha",
    "execution.autoProfileCountryOption.UK": "Reino Unido",
    "execution.autoProfileCountryOption.IT": "Italia",
    "execution.autoProfileCountryOption.BE": "Belgica",
    "execution.autoProfileCountryOption.NL": "Paises Baixos",
    "import.upload.noFile": "Nenhum ficheiro selecionado",
    "import.upload.invalidFile.title": "Ficheiro inválido",
    "import.upload.tooLarge.title": "Ficheiro demasiado grande",
    "import.upload.bc3.invalidFile": "Selecione um ficheiro .bc3",
    "import.upload.bc3.tooLarge": "Selecione um ficheiro BC3 até {limit}.",
    "import.upload.xlsx.invalidFile": "Selecione um ficheiro .xlsx ou .xls",
    "import.upload.xlsx.tooLarge": "Selecione um ficheiro XLSX até {limit}.",
    "import.upload.json.invalidFile": "Selecione um ficheiro .json",
    "import.upload.json.tooLarge": "Selecione um ficheiro JSON até {limit}.",
    "import.upload.json.invalidJson.title": "JSON inválido",
    "import.upload.json.invalidJson.desc": "O ficheiro não é JSON válido. Verifique a sintaxe e tente novamente.",
    "import.upload.json.invalidFormat.title": "Formato inválido",
    "import.upload.json.invalidFormat.desc": "O JSON deve ser um array de itens ou um objecto com a propriedade \"items\" (array).",
    "import.upload.json.emptyItems.title": "Ficheiro sem itens",
    "import.upload.json.emptyItems.desc": "O array \"items\" está vazio. Adicione pelo menos um item antes de importar.",
    "import.upload.json.readError.title": "Erro ao ler ficheiro",
    "import.upload.json.readError.desc": "Não foi possível ler o conteúdo do ficheiro JSON.",
    "import.upload.countryRequired": "País obrigatório",
    "import.upload.dateRequired": "Data de referência obrigatória",
    "import.upload.bc3.started": "Importação iniciada",
    "import.upload.bc3.error": "Erro na importação",
    "import.upload.xlsx.started": "Importação XLSX iniciada",
    "import.upload.xlsx.error": "Erro na importação XLSX",
    "import.upload.json.started": "Importação JSON iniciada",
    "import.upload.json.error": "Erro na importação JSON",
    "import.form.sourceFile.bc3": "Ficheiro BC3 *",
    "import.form.sourceFile.xlsx": "Ficheiro XLSX *",
    "import.form.sourceFile.json": "Ficheiro JSON *",
    "import.form.sourceName": "Nome da fonte",
    "import.form.country": "País *",
    "import.form.countryOptional": "País",
    "import.form.region": "Região",
    "import.form.referenceDate": "Data de referência *",
    "import.form.referenceDateOptional": "Data de referência",
    "import.form.dataTier": "Tipo de dado *",
    "import.form.dataTierOptional": "Tipo de dado",
    "import.form.sheetName": "Nome da sheet",
    "import.action.importing": "A importar...",
    "import.action.importBC3": "Importar BC3",
    "import.action.importXLSX": "Importar XLSX",
    "import.action.importJSON": "Importar JSON do scraper",
    "import.action.downloadTemplate": "Baixar modelo JSON",
    "import.action.downloadSample": "Baixar amostra PT/ES",
    "import.action.sampleDisclaimer": "A amostra PT/ES é apenas para teste/demonstração.",
    "import.action.normalize": "Normalizar",
    "import.action.review": "Revisão",
    "import.action.health": "Saúde",
    "import.action.viewRows": "Ver linhas",
    "import.action.close": "Fechar",
    "import.action.refresh": "Atualizar",
    "import.normalize.done": "Normalização concluída",
    "import.normalize.error": "Erro na normalização",
    "import.card.bc3.title": "Importar ficheiro BC3",
    "import.card.bc3.desc": "Carregue um ficheiro FIEBDC-3 (.bc3) e preencha os metadados da fonte. Os dados ficam em staging para revisão.",
    "import.card.xlsx.title": "Importar ficheiro XLSX",
    "import.card.xlsx.desc": "Carregue uma base de custos em Excel (.xlsx). O parser detecta automaticamente as colunas de código, descrição, unidade e preço.",
    "import.card.json.title": "Importar JSON do scraper",
    "import.card.json.desc": "Carregue um JSON produzido por scraper externo. As linhas ficam em staging para normalização e revisão.",
    "import.card.jobs.title": "Importações",
    "import.card.jobs.emptyState": "Nenhuma importação ainda. Selecione um ficheiro .bc3, .xlsx ou .json acima para começar.",
    "import.disclaimer.rawData.title": "Dados brutos",
    "import.disclaimer.rawData.desc": "Os dados importados ainda não foram normalizados, validados ou ligados ao orçamento. Esta fase serve apenas para inspeção do conteúdo do ficheiro.",
    "import.disclaimer.history.title": "Referência histórica",
    "import.disclaimer.history.desc": "Preços importados são referências históricas de uma fonte externa. Não devem ser tratados como preço final de mercado.",
    "import.disclaimer.normalize.title": "Normalização",
    "import.disclaimer.normalize.desc": "A normalização cria sugestões e conflitos para revisão. Nenhum item é aprovado automaticamente nem inserido nas tabelas canónicas.",
    "import.jobs.file": "Ficheiro",
    "import.jobs.format": "Formato",
    "import.jobs.country": "País",
    "import.jobs.region": "Região",
    "import.jobs.refDate": "Data ref.",
    "import.jobs.type": "Tipo",
    "import.jobs.health": "Saúde",
    "import.jobs.rows": "Linhas",
    "import.jobs.mapped": "Mapeadas",
    "import.jobs.conflicts": "Conflitos",
    "import.jobs.createdAt": "Criado em",
    "import.jobs.actions": "Ações",
    "import.rawRows.title": "Linhas brutas",
    "import.rawRows.desc": "Amostra das linhas de cost_import_raw_rows. Dados ainda não normalizados.",
    "import.rawRows.parserWarnings": "Avisos do parser",
    "import.rawRows.empty": "Nenhuma linha encontrada para este job.",
    "import.rawRows.header.type": "Tipo",
    "import.rawRows.header.code": "Código",
    "import.rawRows.header.description": "Descrição",
    "import.rawRows.header.unit": "Unidade",
    "import.rawRows.header.unitPrice": "Preço unit.",
    "import.rawRows.header.parent": "Pai",
    "import.rawRows.header.coef": "Coef.",
    "import.rawRows.header.status": "Estado",
    "import.rowType.chapter": "Capítulo",
    "import.rowType.composition": "Composição",
    "import.rowType.resource": "Insumo",
    "import.rowType.concept": "Conceito",
    "import.rowType.compositionItem": "Item comp.",
    "import.rowType.text": "Texto",
    "import.health.title": "Saúde da importação",
    "import.health.stats.rows": "Linhas",
    "import.health.stats.mappings": "Mapeamentos",
    "import.health.stats.conflicts": "Conflitos",
    "import.health.stat.totalImported": "Total importadas",
    "import.health.stat.pending": "Pendentes",
    "import.health.stat.mapped": "Mapeadas",
    "import.health.stat.conflict": "Conflito",
    "import.health.stat.skipped": "Ignoradas",
    "import.health.stat.failed": "Com erros",
    "import.health.stat.suggested": "Sugeridos",
    "import.health.stat.approved": "Aprovados",
    "import.health.stat.rejected": "Rejeitados",
    "import.health.stat.openConflicts": "Abertos",
    "import.health.stat.resolvedConflicts": "Resolvidos",
    "import.health.stat.ignoredConflicts": "Ignorados",
    "import.health.preflight.title": "Preflight",
    "import.health.preflight.noApproved": "Aprove mapeamentos na aba Revisão para activar o preflight.",
    "import.health.preflight.simulating": "A simular promoção…",
    "import.health.preflight.promotable": "Promovíveis",
    "import.health.preflight.blocked": "Bloqueados",
    "import.health.preflight.alreadyPromoted": "Já promovidos",
    "import.health.preflight.simNote": "Simulação. Nada foi inserido. Use Revisão para promover.",
    "import.health.preflight.clear": "Limpar",
    "import.health.preflight.check": "Verificar",
    "import.health.preflight.error": "Erro. Tente novamente.",
    "import.health.quality.title": "Avisos de qualidade",
    "import.health.quality.noCountry": "Importação sem país de origem definido.",
    "import.health.quality.sampleNote": "Alertas de qualidade baseados nos primeiros",
    "import.health.status.imported": "Importado",
    "import.health.status.normalized": "Normalizado",
    "import.health.status.pendingReview": "Revisão pendente",
    "import.health.status.readyToPromote": "Pronto p/ promoção",
    "import.health.status.promoted": "Promovido",
    "import.health.status.problems": "Com problemas",
    "import.health.status.processing": "A processar",
    "import.health.status.imported.desc": "Ficheiro carregado. Aguarda normalização.",
    "import.health.status.normalized.desc": "Linhas analisadas. Sem mapeamentos gerados.",
    "import.health.status.pendingReview.desc": "Mapeamentos e/ou conflitos aguardam revisão manual.",
    "import.health.status.readyToPromote.desc": "Mapeamentos aprovados prontos para gerar referências de preço.",
    "import.health.status.promoted.desc": "Referências de preço geradas com sucesso.",
    "import.health.status.problems.desc": "Erro na importação ou falha de processamento.",
    "import.health.pagination.note": "Os contadores de saúde refletem a página atual — use a aba Revisão para navegar.",
    "import.review.card.title": "Revisão",
    "import.review.card.desc": "Reveja os mapeamentos sugeridos e resolva conflitos. Nenhuma alteração ao orçamento ocorre nesta fase.",
    "import.review.alert.approvalNote": "A aprovação apenas confirma o mapeamento. Nenhum preço é enviado ao orçamento nesta fase.",
    "import.review.alert.openConflicts": "Conflitos devem ser revistos manualmente antes de gerar observações de preço.",
    "import.review.tab.mappings": "Mapeamentos",
    "import.review.tab.conflicts": "Conflitos",
    "import.review.mappings.header.code": "Código",
    "import.review.mappings.header.description": "Descrição",
    "import.review.mappings.header.unit": "Unidade",
    "import.review.mappings.header.normUnit": "Un. norm.",
    "import.review.mappings.header.type": "Tipo",
    "import.review.mappings.header.conf": "Conf.",
    "import.review.mappings.header.trace": "Rastreio",
    "import.review.mappings.header.method": "Método",
    "import.review.mappings.header.status": "Estado",
    "import.review.mappings.header.actions": "Ações",
    "import.review.mappings.loading": "A carregar mapeamentos…",
    "import.review.mappings.empty": "Nenhum mapeamento gerado para este job.",
    "import.review.mappings.noResults": "Nenhum resultado para os filtros aplicados.",
    "import.review.conflicts.header.type": "Tipo",
    "import.review.conflicts.header.severity": "Severidade",
    "import.review.conflicts.header.message": "Mensagem",
    "import.review.conflicts.header.status": "Estado",
    "import.review.conflicts.header.actions": "Ações",
    "import.review.conflicts.loading": "A carregar conflitos…",
    "import.review.conflicts.empty": "Nenhum conflito registado para este job.",
    "import.review.conflicts.resolve": "Resolver",
    "import.review.conflicts.ignore": "Ignorar",
    "import.review.conflicts.selectCandidate": "Selecione candidato…",
    "import.review.conflicts.noCandidates": "Sem candidatos automáticos",
    "import.review.conflicts.selectToResolve": "Selecione um candidato para ativar \"Resolver\"",
    "import.review.conflicts.candidateRequired.title": "Candidato obrigatório",
    "import.review.conflicts.candidateRequired.desc": "Selecione um candidato antes de resolver o conflito.",
    "import.review.conflicts.resolveError.title": "Erro ao resolver conflito",
    "import.review.conflicts.ignoreError.title": "Erro ao ignorar conflito",
    "import.review.conflicts.noResults": "Nenhum resultado para os filtros aplicados.",
    "import.filter.search.mappings": "Pesquisar código, descrição, fonte, unidade…",
    "import.filter.search.conflicts": "Pesquisar mensagem, fonte…",
    "import.filter.status": "Estado:",
    "import.filter.lowConf": "Conf. baixa",
    "import.sort.description": "Descrição",
    "import.sort.price": "Preço",
    "import.sort.date": "Data",
    "import.sort.confidence": "Confiança",
    "import.sort.message": "Mensagem",
    "import.status.suggested": "Sugerido",
    "import.status.approved": "Aprovado",
    "import.status.rejected": "Rejeitado",
    "import.status.open": "Aberto",
    "import.status.resolved": "Resolvido",
    "import.status.ignored": "Ignorado",
    "import.batch.executing": "A processar ação em lote…",
    "import.batch.conflict.executing": "A processar conflitos em lote…",
    "import.batch.approve": "Aprovar",
    "import.batch.reject": "Rejeitar",
    "import.batch.resolve": "Resolver",
    "import.batch.ignore": "Ignorar",
    "import.batch.clear": "Limpar",
    "import.batch.confirm": "Confirmar",
    "import.batch.cancel": "Cancelar",
    "import.batch.error.title": "Erro na ação em lote",
    "import.batch.approve.partial": "Aprovação parcial",
    "import.batch.reject.partial": "Rejeição parcial",
    "import.batch.approve.done": "Aprovação concluída",
    "import.batch.reject.done": "Rejeição concluída",
    "import.batch.conflict.resolve.partial": "Resolução parcial",
    "import.batch.conflict.ignore.partial": "Ignorados parcialmente",
    "import.batch.conflict.resolve.done": "Conflitos resolvidos",
    "import.batch.conflict.ignore.done": "Conflitos ignorados",
    "import.batch.conflict.resolve.blocked.title": "Resolução em lote bloqueada",
    "import.batch.conflict.resolve.blocked.desc": "Todos os conflitos selecionados e visíveis precisam ter exatamente 1 candidato.",
    "import.pagination.page": "Página",
    "import.pagination.of": "de",
    "import.pagination.prev": "← Anterior",
    "import.pagination.next": "Próxima →",
    "import.promote.check": "Verificar promoção",
    "import.promote.validating": "A validar mapeamentos aprovados…",
    "import.promote.preflight.done": "Preflight concluído. Nada foi inserido em price_observations.",
    "import.promote.approved.label": "aprovados",
    "import.promote.promotable.label": "promovíveis",
    "import.promote.blocked.label": "bloqueados",
    "import.promote.alreadyPromoted.label": "já promovidos",
    "import.promote.reasons": "Principais motivos:",
    "import.promote.button.valid": "Promover itens válidos",
    "import.promote.button.promote": "Promover",
    "import.promote.cancel": "Cancelar",
    "import.promote.promoting": "A gerar referências de preço…",
    "import.promote.result.simulation": "Simulação concluída",
    "import.promote.result.done": "Referências geradas",
    "import.promote.result.close": "Fechar",
    "import.promote.error.preflight": "Erro no preflight",
    "import.promote.error.generate": "Erro ao gerar referências",
    "import.promote.problem.missingDescription": "Descrição em falta",
    "import.promote.problem.missingUnit": "Unidade em falta",
    "import.promote.problem.invalidUnitPrice": "Preço inválido",
    "import.promote.problem.missingCountry": "País em falta",
    "import.promote.problem.invalidReferenceDate": "Data inválida",
    "import.promote.problem.invalidDataTier": "Tier inválido",
    "import.promote.problem.invalidConfidenceScore": "Confiança inválida",
    "import.promote.problem.alreadyPromoted": "Já promovido",
    "import.trace.noMetadata": "Sem metadados adicionais",
    "import.trace.rawData": "Dados brutos",
    "import.trace.openSource": "Abrir fonte",
    "import.trace.scraperWarning": "Preço importado de fonte externa. Validar antes de aprovar.",
    "import.trace.scraperTag": "scraper",
    "import.trace.importTag": "import",
    "import.summary.totalRows": "Total linhas",
    "import.summary.mapped": "Mapeadas",
    "import.summary.conflicts": "Conflitos",
  },
  en: {
    "common.close": "Close",
    "common.retry": "Try again",
    "common.error": "Error",
    "review.pending.title": "Preparing final review",
    "review.pending.description": "Final totals and validations are still being calculated. Please wait a moment before saving the budget.",
    "common.optional": "Optional",
    "common.country": "Country",
    "common.region": "Region",
    "common.type": "Type",
    "common.name": "Name",
    "common.value": "Value",
    "common.year": "Year",
    "common.month": "Month",
    "nav.section.management": "Management",
    "nav.section.commercial": "Commercial",
    "nav.section.bim": "BIM",
    "nav.section.execution": "Execution",
    "nav.section.directory": "Directory",
    "nav.dashboard": "Panel",
    "nav.analytics": "Analytics",
    "nav.budgets": "Budgets",
    "nav.templates": "Templates",
    "nav.documents": "Documents",
    "nav.revitImport": "Import Revit",
    "nav.works": "Works",
    "nav.measurementAutos": "Measurement Certificates",
    "nav.costDatabase": "Cost database",
    "nav.contacts": "Contacts",
    "nav.settings": "Settings",
    "nav.help": "Help",
    "nav.newBudget": "New budget",
    "costDatabase.eyebrow": "Technical directory",
    "costDatabase.title": "Cost database",
    "costDatabase.description": "Operational catalog of resources, compositions, and sources. This is where Excel, CSV, and BC3 enter before they are used in the editor or IFC.",
    "costDatabase.priceIntelligence": "Price intelligence",
    "costDatabase.priceIntelligenceTitle": "Use this to analyze history, variation, and reliability for imported or registered prices.",
    "costDatabase.card.import.title": "Import",
    "costDatabase.card.import.desc": "Excel, CSV, and BC3 feed the same resource and composition library.",
    "costDatabase.card.compositions.title": "Compositions",
    "costDatabase.card.compositions.desc": "Each composition is ready to be linked to items, chapters, and IFC elements.",
    "costDatabase.card.traceability.title": "Traceability",
    "costDatabase.card.traceability.desc": "Sources and reference dates make prices defensible in real proposals.",
    "costDatabase.tab.resources": "Resources",
    "costDatabase.tab.compositions": "Compositions",
    "costDatabase.tab.sources": "Sources",
    "costDatabase.tab.imports": "Imports",
    "costDatabase.tab.indices": "Indices",
    "costDatabase.action.importExcel": "Import Excel",
    "costDatabase.action.importBC3": "Import BC3",
    "costDatabase.resources.title": "Resources",
    "costDatabase.resources.desc": "Catalog of materials, labor, and equipment with unit prices.",
    "costDatabase.compositions.title": "Cost Compositions",
    "costDatabase.compositions.desc": "Groups of resources that define the unit cost of a work item. Expand each composition to manage its resources.",
    "costDatabase.sources.title": "Price Sources",
    "costDatabase.sources.desc": "Track price origin and reliability: suppliers, public tables, and internal work history.",
    "costDatabase.imports.xlsxNoteTitle": "Automatic XLSX detection:",
    "costDatabase.imports.xlsxNoteDesc": "the parser looks for common PT/ES/EN headers such as code, description, unit, and price. Files outside that pattern enter staging for review and are not approved automatically.",
    "costDatabase.imports.bc3NoteTitle": "BC3/FIEBDC:",
    "costDatabase.imports.bc3NoteDesc": "V1 reads basic concepts and relationships from FIEBDC-3 files. Specific dialect records remain as warnings for later normalization.",
    "costDatabase.indices.title": "Indices and update",
    "costDatabase.indices.desc": "Update historical prices using manually registered indices or CSV.",
    "priceSource.countSingular": "price source",
    "priceSource.countPlural": "price sources",
    "priceSource.new": "New source",
    "priceSource.created": "Source created",
    "priceSource.deleted": "Source deleted",
    "priceSource.deleteConfirm": "Delete source \"{name}\"?",
    "priceSource.deleteTitle": "Delete price source?",
    "priceSource.deleteDescription": "The source \"{name}\" will be removed from the cost database. This action cannot be undone.",
    "costDatabase.resource.deleteTitle": "Delete resource?",
    "costDatabase.resource.deleteDescription": "The resource \"{name}\" will be removed from the cost database. This action cannot be undone.",
    "costDatabase.resource.deleted": "Resource deleted",
    "costDatabase.resource.inUseError": "Resource is in use - remove it from compositions first",
    "costDatabase.composition.deleteTitle": "Delete composition?",
    "costDatabase.composition.deleteDescription": "The composition \"{name}\" will be removed from the cost database. This action cannot be undone.",
    "costDatabase.composition.deleted": "Composition deleted",
    "costDatabase.compositionItem.removeTitle": "Remove resource from composition?",
    "costDatabase.compositionItem.removeDescription": "This resource will be removed from the composition. This action cannot be undone.",
    "priceSource.empty": "Register price origins: suppliers, public tables, internal history...",
    "priceSource.dialogTitle": "New price source",
    "priceSource.namePlaceholder": "LNEC 2024, Supplier X...",
    "priceSource.reliability": "Reliability",
    "priceSource.referenceDate": "Reference date",
    "priceSource.create": "Create source",
    "priceSource.type.manual": "Manual",
    "priceSource.type.supplier": "Supplier",
    "priceSource.type.internal_history": "Internal history",
    "priceSource.type.public_table": "Public table",
    "priceSource.type.csv_import": "CSV import",
    "priceSource.type.estimate": "Estimate",
    "priceSource.reliability.high": "High",
    "priceSource.reliability.medium": "Medium",
    "priceSource.reliability.low": "Low",
    "priceSource.reliability.unknown": "Unknown",
    "costIndex.sourceType.official_index": "Official index",
    "costIndex.sourceType.inflation_index": "Inflation",
    "costIndex.sourceType.construction_cost_index": "Construction cost",
    "costIndex.sourceType.manual_index": "Manual",
    "costIndex.family.labor": "Labor",
    "costIndex.family.material": "Materials",
    "costIndex.family.equipment": "Equipment",
    "costIndex.family.energy": "Energy",
    "costIndex.family.transport": "Transport",
    "costIndex.family.total_construction": "Total construction",
    "costIndex.family.steel": "Steel",
    "costIndex.family.cement": "Cement",
    "costIndex.family.concrete": "Concrete",
    "costIndex.family.timber": "Timber",
    "costIndex.family.fuel": "Fuel",
    "costIndex.family.other": "Other",
    "costIndex.sources.title": "Index sources",
    "costIndex.sources.desc": "Register manual or official sources without connecting automated searches.",
    "costIndex.sourceNamePlaceholder": "INE, INE ES, internal source...",
    "costIndex.publisher": "Publisher",
    "costIndex.monthly.title": "Monthly index",
    "costIndex.monthly.desc": "Register base and target values by cost family.",
    "costIndex.source": "Source",
    "costIndex.selectSource": "Select source",
    "costIndex.family": "Family",
    "costIndex.basePeriod": "Base period",
    "costIndex.basePeriodPlaceholder": "e.g. 2020=100",
    "costIndex.saveIndex": "Save index",
    "costIndex.importCsv": "Import CSV",
    "costIndex.run.title": "Run empirical update",
    "costIndex.run.desc": "Creates estimates in a dedicated table. It does not change observations, budgets, or PDFs.",
    "costIndex.targetYear": "Target year",
    "costIndex.targetMonth": "Target month",
    "costIndex.mode": "Mode",
    "costIndex.mode.dry": "Simulate",
    "costIndex.mode.real": "Create estimates",
    "costIndex.runAdjustment": "Run adjustment",
    "costIndex.registeredSources": "Registered sources",
    "costIndex.previousRuns": "Previous runs",
    "costIndex.recentIndices": "Recent indices",
    "costIndex.empty.sources": "No index sources yet.",
    "costIndex.empty.runs": "No runs yet.",
    "costIndex.empty.indices": "No monthly indices yet.",
    "costIndex.adjustedLine": "{adjusted}/{processed} adjusted. Failures: {failed}.",
    "costIndex.summary.simulation": "Simulation summary",
    "costIndex.summary.execution": "Execution summary",
    "costIndex.summaryLine": "{adjusted} adjusted, {alreadyExists} already existing, {failed} failed, {processed} processed.",
    "costIndex.toast.sourceCreated": "Index source created",
    "costIndex.toast.indexCreated": "Monthly index created",
    "costIndex.toast.indicesImported": "Indices imported",
    "costIndex.toast.rowsLoaded": "{count} rows loaded.",
    "costIndex.toast.simulationDone": "Simulation completed",
    "costIndex.toast.updateDone": "Update completed",
    "costIndex.toast.localSimulation": "{summary} Edge Function unavailable; local simulation was used.",
    "costIndex.error.createSource": "Could not create the source.",
    "costIndex.error.createIndex": "Could not create the index.",
    "costIndex.error.importCsv": "Could not import the CSV.",
    "costIndex.error.runAdjustment": "Could not run the adjustment.",
    "costIndex.error.emptyCsv": "CSV has no valid rows. Use headers: index_family,period_year,period_month,index_value.",
    "costIndex.error.estimatesNeedEdgeFunction": "Estimate creation requires the cost-adjust-prices Edge Function.",
    "dashboard.duplicate.action": "Duplicate",
    "dashboard.duplicate.suffix": "(copy)",
    "dashboard.duplicate.createdTitle": "Budget duplicated",
    "dashboard.duplicate.createdDescription": "A new draft copy was created.",
    "dashboard.list.actions": "Budget actions",
    "dashboard.empty.title": "Start with your first technical budget",
    "dashboard.empty.description":
      "Configure company details, create the first budget, and prepare the base for PDFs, measurements, certificates, and technical review.",
    "dashboard.empty.settings": "Configure company",
    "dashboard.empty.newBudget": "Create first budget",
    "dashboard.empty.noBudgetsTitle": "No budgets yet",
    "dashboard.empty.noBudgetsDescription":
      "Start with a technical budget, or first prepare company details, the cost database, and BIM/IFC files. These steps help generate clearer and more traceable documents.",
    "dashboard.empty.reviewPlan": "Review plan limits",
    "dashboard.empty.settingsDescription": "Company details for PDFs and documents.",
    "dashboard.empty.ifcTitle": "Import BIM/IFC",
    "dashboard.empty.ifcDescription": "Prepare files and technical mappings.",
    "dashboard.empty.costDatabaseTitle": "Cost database",
    "dashboard.empty.costDatabaseDescription": "Organize reusable inputs and compositions.",
    "dashboard.deleteDialog.title": "Delete budget?",
    "dashboard.deleteDialog.description": "This action cannot be undone.",
    "dashboard.deleteBlocked.title": "This budget cannot be deleted",
    "dashboard.deleteBlocked.description": "Sent or approved budgets cannot be deleted.",
    "dashboard.deleted": "Budget deleted",
    "ifcImport.compareDialog.title": "Compare with the previous model?",
    "ifcImport.compareDialog.description": "This budget already has an IFC model linked. You can compare the new model with the previous version before finishing the BIM review.",
    "ifcImport.compareDialog.skip": "Continue without comparing",
    "ifcImport.compareDialog.confirm": "Compare models",
    "ifcImport.compareGenerated": "IFC comparison generated",
    "dashboard.cockpit.eyebrow": "Operational panel",
    "dashboard.painel.title": "Overview",
    "dashboard.cockpit.title": "Organize budgets, documents, and next steps",
    "dashboard.cockpit.description":
      "A quick view for engineering teams to track proposals, versions, and commercial capacity.",
    "dashboard.cockpit.portfolio": "Budgets",
    "dashboard.next.budget": "Next budget",
    "dashboard.next.blocked": "Review plan limit",
    "dashboard.next.ready": "Ready to create",
    "dashboard.next.status": "Account",
    "dashboard.next.company": "Access",
    "dashboard.next.admin": "Admin control active",
    "dashboard.next.member": "Member workspace",
    "dashboard.attention.eyebrow": "Attention needed",
    "dashboard.attention.title": "Next steps",
    "dashboard.attention.clear": "No critical actions",
    "dashboard.attention.clearDescription": "Operations are ready for new budgets and commercial follow-up.",
    "dashboard.attention.companyTitle": "Complete company identity",
    "dashboard.attention.companyDescription": "Fill commercial details before sending real proposals.",
    "dashboard.attention.draftsTitle": "Drafts to finish",
    "dashboard.attention.draftsDescription": "budgets still need review before sending.",
    "dashboard.attention.sentTitle": "Sent proposals",
    "dashboard.attention.sentDescription": "budgets are awaiting commercial follow-up.",
    "dashboard.attention.limitTitle": "Plan capacity reached",
    "dashboard.attention.invitesTitle": "Pending invites",
    "dashboard.attention.invitesDescription": "invites are waiting for acceptance.",
    "dashboard.attention.viewDrafts": "View drafts",
    "dashboard.attention.viewSent": "View sent",
    "dashboard.attention.manageTeam": "Manage team",
    "dashboard.summary.loading": "Loading dashboard summary",
    "dashboard.summary.activeBudgets": "Active budgets",
    "dashboard.summary.totalSuffix": "in total",
    "dashboard.summary.readyToExport": "Ready to export",
    "dashboard.summary.approvedBudgets": "Approved budgets",
    "dashboard.summary.noneApproved": "No approved budgets yet",
    "dashboard.summary.needsAction": "Action needed",
    "dashboard.summary.draftsOrSent": "Drafts or sent",
    "dashboard.summary.costDatabase": "Cost database",
    "dashboard.summary.compositionAbbrev": "comp.",
    "dashboard.summary.resourcesSuffix": "inputs",
    "dashboard.summary.latestTotal": "Latest total",
    "dashboard.summary.latestCalculation": "From the latest calculation",
    "identification.clientName": "Client",
    "identification.clientNamePlaceholder": "Client or entity name",
    "settings.adminOnly": "Only administrators can change company settings.",
    "settings.adminOnlyHint":
      "These settings affect commercial documents. Ask an administrator to change them.",
    "settings.section.admin.eyebrow": "Administration",
    "settings.section.admin.title": "Plan, team, and control",
    "settings.section.admin.description":
      "Manage access, commercial limits, and trust signals for the organization.",
    "settings.section.company.eyebrow": "Commercial identity",
    "settings.section.company.title": "Company and documents",
    "settings.section.company.description":
      "Information used in proposals, PDFs, and client-facing material.",
    "wizard.editBudget": "Edit budget",
    "wizard.updated": "Budget updated",
    "dashboard.version.createdTitle": "New version created",
    "dashboard.version.createdDescriptionSuffix": "available in history.",
    "dashboard.version.new": "New version",
    "dashboard.version.history": "Version history",
    "dashboard.version.singular": "version",
    "dashboard.version.plural": "versions",
    "dashboard.version.fallbackBudgetName": "Budget",
    "dashboard.version.current": "current version",
    "dashboard.version.createdFrom": "created from",
    "dashboard.version.open": "Open",
    "dashboard.version.version": "Version",
    "dashboard.version.baseCost": "Base cost",
    "dashboard.version.snapshotNote":
      "Snapshot preserved for future comparison and PDF export by version.",
    "dashboard.version.create": "Create new version",
    "commerce.planTitle": "Plan and usage",
    "commerce.planDescription": "Company commercial status and current account limits.",
    "commerce.plan.trialLabel": "Free",
    "commerce.status.trial": "free",
    "commerce.status.active": "active",
    "commerce.status.past_due": "past due",
    "commerce.status.canceled": "canceled",
    "commerce.providerReady": "Account linked to a billing provider.",
    "commerce.providerPending": "Business plan activation is handled by the Orzio team.",
    "commerce.contactSales": "Activate Business",
    "commerce.upgradeCta": "Upgrade plan",
    "commerce.manageSubscription": "Manage subscription",
    "commerce.currentPlan": "Current plan",
    "commerce.planSku.trial": "Trial",
    "commerce.planSku.budget_starter": "Budget Starter",
    "commerce.planSku.budget_pro": "Budget Pro",
    "commerce.planSku.budget_business": "Budget Business",
    "commerce.planSku.takeoff_pro": "Takeoff Pro",
    "commerce.planSku.takeoff_team": "Takeoff Team",
    "commerce.productFamily.budget": "Budget",
    "commerce.productFamily.takeoff": "Takeoff",
    "commerce.trialBannerTitle": "Trial access is active",
    "commerce.trialBannerDescription":
      "Your organization is currently using the trial limits for this product.",
    "commerce.trialEndsAt": "Trial ends",
    "commerce.currentPeriodEndsAt": "Current period ends",
    "commerce.cancelAtPeriodEnd": "Cancellation scheduled for period end",
    "commerce.planUnavailableTitle": "Plan details unavailable",
    "commerce.planUnavailableDescription":
      "We could not load the billing status for this organization yet.",
    "commerce.errorLoadingPlan": "We could not refresh the billing status",
    "commerce.noCustomer": "There is no active subscription to manage yet.",
    "commerce.upgradePromptTitle": "Unlock more capacity",
    "commerce.upgradePromptDescription":
      "Review your current plan to expand limits, manage billing, and unlock more workspace capacity.",
    "commerce.checkoutSuccessTitle": "Subscription activated",
    "commerce.checkoutSuccessDescription": "Thanks. The Business plan is active and your limits have been updated.",
    "commerce.checkoutCanceledTitle": "Checkout canceled",
    "commerce.checkoutCanceledDescription": "Nothing was charged. You can try again anytime.",
    "commerce.reviewPlan": "Review plan",
    "commerce.upgradeRequired": "Upgrade required",
    "commerce.upgrade.budgetLimit":
      "You have reached the active budget limit for the current plan.",
    "commerce.upgrade.versionLimit":
      "You have reached the version limit for the current plan.",
    "commerce.upgrade.exportLimit":
      "You have reached the monthly PDF export limit for the current plan.",
    "commerce.upgrade.moduleRequired":
      "This budget type is not included in the current plan.",
    "commerce.enabledModules": "Included modules",
    "commerce.module.projects": "Project budgets",
    "commerce.module.works": "Works budgets",
    "commerce.activeBudgets": "Active budgets",
    "commerce.members": "Members",
    "commerce.exportsThisMonth": "Exports this month",
    "commerce.aiCredits": "AI credits this month",
    "commerce.unlimited": "unlimited",
    "commerce.planUsageHelp": "Limits are applied at organization level according to the current plan.",
    "commerce.blockedBudgetHelp": "The active budget limit has been reached. Review plan capacity before creating more budgets.",
    "commerce.trialReady": "Free plan",
    "commerce.businessReady": "Business active",
    "commerce.exportBlockedTitle": "Export blocked by plan",
    "team.title": "Team",
    "team.description": "Manage internal access with invitations prepared for onboarding delivery.",
    "team.adminOnly": "Only administrators can manage the team.",
    "team.invite": "Invite",
    "team.inviteEmailLabel": "Invite email",
    "team.inviteRoleLabel": "Invite role",
    "team.memberRoleLabel": "Member role",
    "team.inviteEmailPlaceholder": "colleague@company.com",
    "team.inviteCreated": "Invite created",
    "team.inviteProviderReady": "The invitation is prepared. Email delivery can be enabled when the provider is connected.",
    "team.inviteEmailSent": "Invitation email sent.",
    "team.inviteEmailPending": "Invitation created. Email delivery is not configured yet.",
    "team.inviteEmailFailed": "Invitation created, but email delivery failed. Copy the link manually.",
    "team.memberLimitReached": "The member limit for the current plan has been reached. Review the plan before inviting more people.",
    "team.roleUpdated": "Role updated",
    "team.memberRemoved": "Member removed",
    "team.inviteRevoked": "Invite revoked",
    "team.members": "Members",
    "team.noMembers": "There are no other members in this organization yet.",
    "team.pendingInvites": "Pending invites",
    "team.noPendingInvites": "No pending invites.",
    "team.inviteReference": "Secure reference",
    "team.invitePrepared": "Ready to send",
    "team.inviteAcceptanceReady": "Acceptance link prepared",
    "team.copyInviteLink": "Copy link",
    "team.inviteLinkCopied": "Invite link copied",
    "team.revoke": "Revoke",
    "team.remove": "Remove",
    "team.confirmRemoveTitle": "Remove member?",
    "team.confirmRemoveDescription": "This user will lose access to the organization. They can be invited again later.",
    "team.confirmRevokeTitle": "Revoke invite?",
    "team.confirmRevokeDescription": "This pending invite will no longer be usable.",
    "team.confirmAction": "Confirm",
    "team.permissions": "Permissions",
    "team.subaccessPermissions": "Sub-access permissions",
    "team.subaccessPlanRequiredTitle": "Sub-access requires a paid plan",
    "team.subaccessPlanRequiredDescription":
      "Upgrade to the Business plan to invite and manage sub-access for your organization. Your budgets and data remain accessible.",
    "activity.title": "Recent activity",
    "activity.description": "A quick signal of critical actions recorded for support and audit.",
    "activity.empty": "No critical activity has been recorded yet.",
    "activity.systemActor": "System",
    "team.role.member": "Member",
    "team.role.admin": "Admin",
    "invite.title": "Accept invite",
    "invite.description": "Confirm access to join the organization.",
    "invite.organizationFallback": "Inviting organization",
    "invite.accept": "Accept invite",
    "invite.acceptedTitle": "Invite accepted",
    "invite.acceptedDescription": "Organization access has been confirmed securely.",
    "invite.acceptFailed": "The invite could not be accepted.",
    "invite.goDashboard": "Go to Dashboard",
    "invite.invalidTitle": "Invite unavailable",
    "invite.invalidDescription": "This invite cannot be used. Ask an administrator for a new invite.",
    "invite.signInRequired": "Sign in with the invited email address to accept this access.",
    "invite.signIn": "Sign in to accept",
    "invite.supportHint": "If access fails, ask an administrator to confirm the invited email, invite status, and link validity.",
    "invite.status.invalid": "The link does not match a valid invite.",
    "invite.status.revoked": "This invite was revoked.",
    "invite.status.expired": "This invite has expired.",
    "invite.status.accepted": "This invite has already been accepted.",
    "invite.status.pending": "This invite is ready for acceptance.",
    "execution.open": "Execution and measurement",
    "execution.backToDashboard": "Back to Dashboard",
    "execution.eyebrow": "4D execution and certificates",
    "execution.title": "Execution and measurement",
    "execution.subtitle": "Manage the execution plan, site measurements, and prepared measurement certificates from the approved budget.",
    "execution.generatePlan": "Generate execution plan",
    "execution.refreshPlan": "Refresh plan",
    "execution.planGenerated": "Plan prepared",
    "execution.tasksPrepared": "tasks ready for tracking",
    "execution.tasks": "Tasks",
    "execution.tasksHelper": "Operational items linked to the budget",
    "execution.inProgress": "In progress",
    "execution.inProgressHelper": "Tasks with active progress",
    "execution.completed": "Completed",
    "execution.completedHelper": "Tasks marked complete",
    "execution.autos": "Certificates",
    "execution.autosHelper": "Prepared certificate lines",
    "execution.emptyTitle": "No execution plan yet",
    "execution.emptyDescription": "Generate the first operational structure from the real items in this budget.",
    "execution.plan": "Plan",
    "execution.measurements": "Measurements",
    "execution.taskRegister": "Task register",
    "execution.taskRegisterDescription": "Track phases, planned quantities, status, and progress.",
    "execution.phase": "Phase",
    "execution.task": "Task",
    "execution.planned": "Planned",
    "execution.status": "Status",
    "execution.progress": "Progress",
    "execution.progressPercentHint": "Enter a value between 0 and 100%.",
    "execution.editTask": "Update task",
    "execution.editTaskDescription": "Edit only safe operational fields in this first version.",
    "execution.plannedStart": "Planned start",
    "execution.plannedEnd": "Planned end",
    "execution.actualStart": "Actual start",
    "execution.actualEnd": "Actual end",
    "execution.notes": "Notes",
    "execution.saveTask": "Save task",
    "execution.taskSaved": "Task updated",
    "execution.selectTask": "Select a task to edit.",
    "execution.dependencies": "Dependencies",
    "execution.dependenciesDescription": "Visibility prepared for planning links and a future timeline/Gantt view.",
    "execution.dependenciesReady": "dependencies recorded",
    "execution.dependenciesEmpty": "No dependencies are recorded yet. The structure is ready to evolve.",
    "execution.measurementEntry": "Measurement entry",
    "execution.measurementEntryDescription": "Record measured quantities by task while keeping an auditable history.",
    "execution.previous": "Previous",
    "execution.remaining": "Remaining",
    "execution.current": "Current",
    "execution.measurementCurrentHint": "Quantity for this measurement. Suggested remaining:",
    "execution.measurementQuantityRequired": "Enter a measured quantity greater than zero.",
    "execution.measuredAt": "Measured date",
    "execution.recordMeasurement": "Record measurement",
    "execution.measurementRecorded": "Measurement recorded",
    "execution.accumulated": "Accumulated",
    "execution.measurementHistory": "Measurement history",
    "execution.approvedMeasurements": "approved measurements",
    "execution.measurementsEmpty": "No measurements have been recorded for this budget yet.",
    "execution.value": "Value",
    "execution.unlinkedItem": "Unlinked item",
    "execution.autoWorkflow": "Measurement certificate",
    "execution.autoWorkflowDescription": "Prepare a certificate from approved measurements in the selected period.",
    "execution.periodStart": "Period start",
    "execution.periodEnd": "Period end",
    "execution.generateAuto": "Prepare certificate",
    "execution.autoPrepared": "Certificate prepared",
    "execution.lines": "lines",
    "execution.futurePdf": "The certificate is structured for internal review. Formal PDF rendering can connect to this structure later.",
    "execution.noAutos": "No certificates have been prepared for this budget yet.",
    "execution.autoNoLines": "This certificate has no eligible lines. Approve measurements in the period before generating again.",
    "execution.statusUpdated": "Measurement status updated",
    "execution.certificateStatusUpdated": "Certificate status updated",
    "execution.certified": "Certified",
    "execution.submitReview": "Submit for review",
    "execution.approve": "Approve",
    "execution.reject": "Reject",
    "execution.void": "Void",
    "execution.exportAutoPdf": "Export PDF",
    "execution.pdfPrepared": "PDF prepared",
    "execution.pdfVoidedBlocked": "Voided certificates cannot be rendered.",
    "execution.popupBlocked": "Unable to open the PDF window. Please allow pop-ups for this site.",
    "execution.pdfLastRendered": "Last PDF",
    "execution.pdfNotRendered": "PDF not rendered yet",
    // ── Cost Database Import ───────────────────────────────────────────────────
    "execution.autoProfileLead": "The certificate template controls the country, language, tax fields, and signatures used in preview and PDF export.",
    "execution.autoProfileTitle": "Certificate template",
    "execution.autoProfileDescription": "Choose the operational profile before reviewing or exporting the final document.",
    "execution.autoProfileCountry": "Template country",
    "execution.autoProfileContractType": "Contract type",
    "execution.autoProfileLanguage": "Language",
    "execution.autoProfileFinancialTitle": "Financial fields",
    "execution.autoProfileTaxEnabled": "Enable tax",
    "execution.autoProfileTaxRate": "Tax rate",
    "execution.autoProfileRetentionEnabled": "Enable retention",
    "execution.autoProfileRetentionRate": "Retention percentage",
    "execution.autoProfileSignaturesTitle": "Signatures",
    "execution.autoProfileSignature.contractor": "Include contractor signature",
    "execution.autoProfileSignature.supervisor": "Include supervisor / site direction signature",
    "execution.autoProfileSignature.owner": "Include owner signature",
    "execution.autoProfileLegalTitle": "Operational notice",
    "execution.autoProfileLegalDescription": "This profile is a configurable Orzio operational setup and does not replace legal or contractual validation.",
    "execution.autoProfileCountryFields": "Country-specific fields",
    "execution.autoProfileCountryFieldsEmpty": "This profile does not add country-specific operational fields.",
    "execution.autoProfilePreviewTitle": "Live preview",
    "execution.autoProfilePreviewDescription": "The document below updates immediately from the selected template.",
    "execution.autoProfilePreviewFrameTitle": "Measurement certificate preview",
    "execution.autoProfilePreviewEmpty": "Prepare a certificate to unlock the professional PDF preview.",
    "execution.autoProfileContract.private": "Private",
    "execution.autoProfileContract.public": "Public",
    "execution.autoProfileContract.internal": "Internal / pilot review",
    "execution.autoProfileLanguageOption.pt": "Portuguese",
    "execution.autoProfileLanguageOption.en": "English",
    "execution.autoProfileLanguageOption.es": "Spanish",
    "execution.autoProfileLanguageOption.fr": "French",
    "execution.autoProfileCountryOption.PT": "Portugal",
    "execution.autoProfileCountryOption.ES": "Spain",
    "execution.autoProfileCountryOption.FR": "France",
    "execution.autoProfileCountryOption.DE": "Germany",
    "execution.autoProfileCountryOption.UK": "United Kingdom",
    "execution.autoProfileCountryOption.IT": "Italy",
    "execution.autoProfileCountryOption.BE": "Belgium",
    "execution.autoProfileCountryOption.NL": "Netherlands",
    "import.upload.noFile": "No file selected",
    "import.upload.invalidFile.title": "Invalid file",
    "import.upload.tooLarge.title": "File too large",
    "import.upload.bc3.invalidFile": "Select a .bc3 file",
    "import.upload.bc3.tooLarge": "Select a BC3 file up to {limit}.",
    "import.upload.xlsx.invalidFile": "Select a .xlsx or .xls file",
    "import.upload.xlsx.tooLarge": "Select an XLSX file up to {limit}.",
    "import.upload.json.invalidFile": "Select a .json file",
    "import.upload.json.tooLarge": "Select a JSON file up to {limit}.",
    "import.upload.json.invalidJson.title": "Invalid JSON",
    "import.upload.json.invalidJson.desc": "The file is not valid JSON. Check the syntax and try again.",
    "import.upload.json.invalidFormat.title": "Invalid format",
    "import.upload.json.invalidFormat.desc": "The JSON must be an array of items or an object with an \"items\" property (array).",
    "import.upload.json.emptyItems.title": "File has no items",
    "import.upload.json.emptyItems.desc": "The \"items\" array is empty. Add at least one item before importing.",
    "import.upload.json.readError.title": "Error reading file",
    "import.upload.json.readError.desc": "Unable to read the JSON file content.",
    "import.upload.countryRequired": "Country required",
    "import.upload.dateRequired": "Reference date required",
    "import.upload.bc3.started": "Import started",
    "import.upload.bc3.error": "Import error",
    "import.upload.xlsx.started": "XLSX import started",
    "import.upload.xlsx.error": "XLSX import error",
    "import.upload.json.started": "JSON import started",
    "import.upload.json.error": "JSON import error",
    "import.form.sourceFile.bc3": "BC3 file *",
    "import.form.sourceFile.xlsx": "XLSX file *",
    "import.form.sourceFile.json": "JSON file *",
    "import.form.sourceName": "Source name",
    "import.form.country": "Country *",
    "import.form.countryOptional": "Country",
    "import.form.region": "Region",
    "import.form.referenceDate": "Reference date *",
    "import.form.referenceDateOptional": "Reference date",
    "import.form.dataTier": "Data tier *",
    "import.form.dataTierOptional": "Data tier",
    "import.form.sheetName": "Sheet name",
    "import.action.importing": "Importing...",
    "import.action.importBC3": "Import BC3",
    "import.action.importXLSX": "Import XLSX",
    "import.action.importJSON": "Import scraper JSON",
    "import.action.downloadTemplate": "Download JSON template",
    "import.action.downloadSample": "Download PT/ES sample",
    "import.action.sampleDisclaimer": "The PT/ES sample is for testing and demonstration only.",
    "import.action.normalize": "Normalize",
    "import.action.review": "Review",
    "import.action.health": "Health",
    "import.action.viewRows": "View rows",
    "import.action.close": "Close",
    "import.action.refresh": "Refresh",
    "import.normalize.done": "Normalization complete",
    "import.normalize.error": "Normalization error",
    "import.card.bc3.title": "Import BC3 file",
    "import.card.bc3.desc": "Upload a FIEBDC-3 (.bc3) file and fill in the source metadata. Data is staged for review.",
    "import.card.xlsx.title": "Import XLSX file",
    "import.card.xlsx.desc": "Upload a cost database in Excel (.xlsx). The parser automatically detects code, description, unit and price columns.",
    "import.card.json.title": "Import scraper JSON",
    "import.card.json.desc": "Upload a JSON produced by an external scraper. Rows are staged for normalization and review.",
    "import.card.jobs.title": "Imports",
    "import.card.jobs.emptyState": "No imports yet. Select a .bc3, .xlsx or .json file above to get started.",
    "import.disclaimer.rawData.title": "Raw data",
    "import.disclaimer.rawData.desc": "Imported data has not yet been normalized, validated or linked to any budget. This phase is for inspection only.",
    "import.disclaimer.history.title": "Historical reference",
    "import.disclaimer.history.desc": "Imported prices are historical references from an external source and should not be treated as final market prices.",
    "import.disclaimer.normalize.title": "Normalization",
    "import.disclaimer.normalize.desc": "Normalization creates suggestions and conflicts for review. No item is automatically approved or inserted into canonical tables.",
    "import.jobs.file": "File",
    "import.jobs.format": "Format",
    "import.jobs.country": "Country",
    "import.jobs.region": "Region",
    "import.jobs.refDate": "Ref. date",
    "import.jobs.type": "Type",
    "import.jobs.health": "Health",
    "import.jobs.rows": "Rows",
    "import.jobs.mapped": "Mapped",
    "import.jobs.conflicts": "Conflicts",
    "import.jobs.createdAt": "Created at",
    "import.jobs.actions": "Actions",
    "import.rawRows.title": "Raw rows",
    "import.rawRows.desc": "Sample rows from cost_import_raw_rows. Data not yet normalized.",
    "import.rawRows.parserWarnings": "Parser warnings",
    "import.rawRows.empty": "No rows found for this job.",
    "import.rawRows.header.type": "Type",
    "import.rawRows.header.code": "Code",
    "import.rawRows.header.description": "Description",
    "import.rawRows.header.unit": "Unit",
    "import.rawRows.header.unitPrice": "Unit price",
    "import.rawRows.header.parent": "Parent",
    "import.rawRows.header.coef": "Coef.",
    "import.rawRows.header.status": "Status",
    "import.rowType.chapter": "Chapter",
    "import.rowType.composition": "Composition",
    "import.rowType.resource": "Resource",
    "import.rowType.concept": "Concept",
    "import.rowType.compositionItem": "Comp. item",
    "import.rowType.text": "Text",
    "import.health.title": "Import health",
    "import.health.stats.rows": "Rows",
    "import.health.stats.mappings": "Mappings",
    "import.health.stats.conflicts": "Conflicts",
    "import.health.stat.totalImported": "Total imported",
    "import.health.stat.pending": "Pending",
    "import.health.stat.mapped": "Mapped",
    "import.health.stat.conflict": "Conflict",
    "import.health.stat.skipped": "Skipped",
    "import.health.stat.failed": "Failed",
    "import.health.stat.suggested": "Suggested",
    "import.health.stat.approved": "Approved",
    "import.health.stat.rejected": "Rejected",
    "import.health.stat.openConflicts": "Open",
    "import.health.stat.resolvedConflicts": "Resolved",
    "import.health.stat.ignoredConflicts": "Ignored",
    "import.health.preflight.title": "Preflight",
    "import.health.preflight.noApproved": "Approve mappings in the Review tab to activate preflight.",
    "import.health.preflight.simulating": "Simulating promotion…",
    "import.health.preflight.promotable": "Promotable",
    "import.health.preflight.blocked": "Blocked",
    "import.health.preflight.alreadyPromoted": "Already promoted",
    "import.health.preflight.simNote": "Simulation. Nothing was inserted. Use Review to promote.",
    "import.health.preflight.clear": "Clear",
    "import.health.preflight.check": "Check",
    "import.health.preflight.error": "Error. Try again.",
    "import.health.quality.title": "Quality warnings",
    "import.health.quality.noCountry": "Import has no source country defined.",
    "import.health.quality.sampleNote": "Quality alerts based on the first",
    "import.health.status.imported": "Imported",
    "import.health.status.normalized": "Normalized",
    "import.health.status.pendingReview": "Pending review",
    "import.health.status.readyToPromote": "Ready to promote",
    "import.health.status.promoted": "Promoted",
    "import.health.status.problems": "Has problems",
    "import.health.status.processing": "Processing",
    "import.health.status.imported.desc": "File uploaded. Awaiting normalization.",
    "import.health.status.normalized.desc": "Rows analyzed. No mappings generated.",
    "import.health.status.pendingReview.desc": "Mappings and/or conflicts awaiting manual review.",
    "import.health.status.readyToPromote.desc": "Approved mappings ready to generate price references.",
    "import.health.status.promoted.desc": "Price references generated successfully.",
    "import.health.status.problems.desc": "Import error or processing failure.",
    "import.health.pagination.note": "Health counters reflect the current page — use the Review tab to navigate.",
    "import.review.card.title": "Review",
    "import.review.card.desc": "Review suggested mappings and resolve conflicts. No budget changes occur at this stage.",
    "import.review.alert.approvalNote": "Approval only confirms the mapping. No price is sent to the budget at this stage.",
    "import.review.alert.openConflicts": "Conflicts must be reviewed manually before generating price observations.",
    "import.review.tab.mappings": "Mappings",
    "import.review.tab.conflicts": "Conflicts",
    "import.review.mappings.header.code": "Code",
    "import.review.mappings.header.description": "Description",
    "import.review.mappings.header.unit": "Unit",
    "import.review.mappings.header.normUnit": "Norm. unit",
    "import.review.mappings.header.type": "Type",
    "import.review.mappings.header.conf": "Conf.",
    "import.review.mappings.header.trace": "Trace",
    "import.review.mappings.header.method": "Method",
    "import.review.mappings.header.status": "Status",
    "import.review.mappings.header.actions": "Actions",
    "import.review.mappings.loading": "Loading mappings…",
    "import.review.mappings.empty": "No mappings generated for this job.",
    "import.review.mappings.noResults": "No results for the applied filters.",
    "import.review.conflicts.header.type": "Type",
    "import.review.conflicts.header.severity": "Severity",
    "import.review.conflicts.header.message": "Message",
    "import.review.conflicts.header.status": "Status",
    "import.review.conflicts.header.actions": "Actions",
    "import.review.conflicts.loading": "Loading conflicts…",
    "import.review.conflicts.empty": "No conflicts recorded for this job.",
    "import.review.conflicts.resolve": "Resolve",
    "import.review.conflicts.ignore": "Ignore",
    "import.review.conflicts.selectCandidate": "Select candidate…",
    "import.review.conflicts.noCandidates": "No automatic candidates",
    "import.review.conflicts.selectToResolve": "Select a candidate to enable \"Resolve\"",
    "import.review.conflicts.candidateRequired.title": "Candidate required",
    "import.review.conflicts.candidateRequired.desc": "Select a candidate before resolving the conflict.",
    "import.review.conflicts.resolveError.title": "Error resolving conflict",
    "import.review.conflicts.ignoreError.title": "Error ignoring conflict",
    "import.review.conflicts.noResults": "No results for the applied filters.",
    "import.filter.search.mappings": "Search code, description, source, unit…",
    "import.filter.search.conflicts": "Search message, source…",
    "import.filter.status": "Status:",
    "import.filter.lowConf": "Low conf.",
    "import.sort.description": "Description",
    "import.sort.price": "Price",
    "import.sort.date": "Date",
    "import.sort.confidence": "Confidence",
    "import.sort.message": "Message",
    "import.status.suggested": "Suggested",
    "import.status.approved": "Approved",
    "import.status.rejected": "Rejected",
    "import.status.open": "Open",
    "import.status.resolved": "Resolved",
    "import.status.ignored": "Ignored",
    "import.batch.executing": "Processing batch action…",
    "import.batch.conflict.executing": "Processing conflicts in batch…",
    "import.batch.approve": "Approve",
    "import.batch.reject": "Reject",
    "import.batch.resolve": "Resolve",
    "import.batch.ignore": "Ignore",
    "import.batch.clear": "Clear",
    "import.batch.confirm": "Confirm",
    "import.batch.cancel": "Cancel",
    "import.batch.error.title": "Batch action error",
    "import.batch.approve.partial": "Partial approval",
    "import.batch.reject.partial": "Partial rejection",
    "import.batch.approve.done": "Approval complete",
    "import.batch.reject.done": "Rejection complete",
    "import.batch.conflict.resolve.partial": "Partial resolution",
    "import.batch.conflict.ignore.partial": "Partially ignored",
    "import.batch.conflict.resolve.done": "Conflicts resolved",
    "import.batch.conflict.ignore.done": "Conflicts ignored",
    "import.batch.conflict.resolve.blocked.title": "Batch resolution blocked",
    "import.batch.conflict.resolve.blocked.desc": "All selected and visible conflicts must have exactly 1 candidate.",
    "import.pagination.page": "Page",
    "import.pagination.of": "of",
    "import.pagination.prev": "← Prev",
    "import.pagination.next": "Next →",
    "import.promote.check": "Check promotion",
    "import.promote.validating": "Validating approved mappings…",
    "import.promote.preflight.done": "Preflight complete. Nothing was inserted in price_observations.",
    "import.promote.approved.label": "approved",
    "import.promote.promotable.label": "promotable",
    "import.promote.blocked.label": "blocked",
    "import.promote.alreadyPromoted.label": "already promoted",
    "import.promote.reasons": "Main reasons:",
    "import.promote.button.valid": "Promote valid items",
    "import.promote.button.promote": "Promote",
    "import.promote.cancel": "Cancel",
    "import.promote.promoting": "Generating price references…",
    "import.promote.result.simulation": "Simulation complete",
    "import.promote.result.done": "References generated",
    "import.promote.result.close": "Close",
    "import.promote.error.preflight": "Preflight error",
    "import.promote.error.generate": "Error generating references",
    "import.promote.problem.missingDescription": "Missing description",
    "import.promote.problem.missingUnit": "Missing unit",
    "import.promote.problem.invalidUnitPrice": "Invalid price",
    "import.promote.problem.missingCountry": "Missing country",
    "import.promote.problem.invalidReferenceDate": "Invalid date",
    "import.promote.problem.invalidDataTier": "Invalid tier",
    "import.promote.problem.invalidConfidenceScore": "Invalid confidence",
    "import.promote.problem.alreadyPromoted": "Already promoted",
    "import.trace.noMetadata": "No additional metadata",
    "import.trace.rawData": "Raw data",
    "import.trace.openSource": "Open source",
    "import.trace.scraperWarning": "Price imported from external source. Validate before approving.",
    "import.trace.scraperTag": "scraper",
    "import.trace.importTag": "import",
    "import.summary.totalRows": "Total rows",
    "import.summary.mapped": "Mapped",
    "import.summary.conflicts": "Conflicts",
  },
  es: {
    "common.close": "Cerrar",
    "common.retry": "Intentar de nuevo",
    "common.error": "Error",
    "review.pending.title": "Preparando revision final",
    "review.pending.description": "Los totales y validaciones finales todavia se estan calculando. Espere un momento antes de guardar el presupuesto.",
    "common.optional": "Opcional",
    "common.country": "Pais",
    "common.region": "Region",
    "common.type": "Tipo",
    "common.name": "Nombre",
    "common.value": "Valor",
    "common.year": "Ano",
    "common.month": "Mes",
    "nav.section.management": "Gestion",
    "nav.section.commercial": "Comercial",
    "nav.section.bim": "BIM",
    "nav.section.execution": "Ejecucion",
    "nav.section.directory": "Directorio",
    "nav.dashboard": "Panel",
    "nav.analytics": "Análisis",
    "nav.budgets": "Presupuestos",
    "nav.templates": "Modelos",
    "nav.documents": "Documentos",
    "nav.revitImport": "Importar Revit",
    "nav.works": "Obras",
    "nav.measurementAutos": "Certificaciones",
    "nav.costDatabase": "Base de costes",
    "nav.contacts": "Contactos",
    "nav.settings": "Configuracion",
    "nav.help": "Ayuda",
    "nav.newBudget": "Nuevo presupuesto",
    "costDatabase.eyebrow": "Directorio tecnico",
    "costDatabase.title": "Base de Costes",
    "costDatabase.description": "Catalogo operativo de recursos, composiciones y fuentes. Esta es el area donde entran Excel, CSV y BC3 antes de usarse en el editor o IFC.",
    "costDatabase.priceIntelligence": "Inteligencia de precios",
    "costDatabase.priceIntelligenceTitle": "Use esto para analizar historico, variacion y fiabilidad de precios importados o registrados.",
    "costDatabase.card.import.title": "Importacion",
    "costDatabase.card.import.desc": "Excel, CSV y BC3 alimentan la misma biblioteca de recursos y composiciones.",
    "costDatabase.card.compositions.title": "Composiciones",
    "costDatabase.card.compositions.desc": "Cada composicion queda lista para asociarse a partidas, capitulos y elementos IFC.",
    "costDatabase.card.traceability.title": "Trazabilidad",
    "costDatabase.card.traceability.desc": "Fuentes y fechas de referencia hacen defendible el precio en propuestas reales.",
    "costDatabase.tab.resources": "Recursos",
    "costDatabase.tab.compositions": "Composiciones",
    "costDatabase.tab.sources": "Fuentes",
    "costDatabase.tab.imports": "Importaciones",
    "costDatabase.tab.indices": "Indices",
    "costDatabase.action.importExcel": "Importar Excel",
    "costDatabase.action.importBC3": "Importar BC3",
    "costDatabase.resources.title": "Recursos",
    "costDatabase.resources.desc": "Catalogo de materiales, mano de obra y equipos con precios unitarios.",
    "costDatabase.compositions.title": "Composiciones de Coste",
    "costDatabase.compositions.desc": "Agrupaciones de recursos que definen el coste unitario de una partida. Expanda cada composicion para gestionar sus recursos.",
    "costDatabase.sources.title": "Fuentes de Precio",
    "costDatabase.sources.desc": "Rastree el origen y fiabilidad de los precios: proveedores, tablas publicas e historico de obra.",
    "costDatabase.imports.xlsxNoteTitle": "Deteccion automatica XLSX:",
    "costDatabase.imports.xlsxNoteDesc": "el parser busca cabeceras comunes en PT/ES/EN como codigo, descripcion, unidad y precio. Los ficheros fuera de ese patron entran en staging para revision y no se aprueban automaticamente.",
    "costDatabase.imports.bc3NoteTitle": "BC3/FIEBDC:",
    "costDatabase.imports.bc3NoteDesc": "V1 lee conceptos y relaciones basicas de ficheros FIEBDC-3. Registros de dialectos especificos quedan como avisos para normalizacion posterior.",
    "costDatabase.indices.title": "Indices y actualizacion",
    "costDatabase.indices.desc": "Actualice precios historicos usando indices registrados manualmente o por CSV.",
    "priceSource.countSingular": "fuente de precio",
    "priceSource.countPlural": "fuentes de precio",
    "priceSource.new": "Nueva fuente",
    "priceSource.created": "Fuente creada",
    "priceSource.deleted": "Fuente eliminada",
    "priceSource.deleteConfirm": "Eliminar fuente \"{name}\"?",
    "priceSource.deleteTitle": "Eliminar fuente de precio?",
    "priceSource.deleteDescription": "La fuente \"{name}\" se eliminara de la base de costes. Esta accion no se puede deshacer.",
    "costDatabase.resource.deleteTitle": "Eliminar recurso?",
    "costDatabase.resource.deleteDescription": "El recurso \"{name}\" se eliminara de la base de costes. Esta accion no se puede deshacer.",
    "costDatabase.resource.deleted": "Recurso eliminado",
    "costDatabase.resource.inUseError": "El recurso esta en uso - eliminelo primero de las composiciones",
    "costDatabase.composition.deleteTitle": "Eliminar composicion?",
    "costDatabase.composition.deleteDescription": "La composicion \"{name}\" se eliminara de la base de costes. Esta accion no se puede deshacer.",
    "costDatabase.composition.deleted": "Composicion eliminada",
    "costDatabase.compositionItem.removeTitle": "Eliminar recurso de la composicion?",
    "costDatabase.compositionItem.removeDescription": "Este recurso se eliminara de la composicion. Esta accion no se puede deshacer.",
    "priceSource.empty": "Registre origenes de precios: proveedores, tablas publicas, historico interno...",
    "priceSource.dialogTitle": "Nueva fuente de precio",
    "priceSource.namePlaceholder": "LNEC 2024, Proveedor X...",
    "priceSource.reliability": "Fiabilidad",
    "priceSource.referenceDate": "Fecha de referencia",
    "priceSource.create": "Crear fuente",
    "priceSource.type.manual": "Manual",
    "priceSource.type.supplier": "Proveedor",
    "priceSource.type.internal_history": "Historico interno",
    "priceSource.type.public_table": "Tabla publica",
    "priceSource.type.csv_import": "Importacion CSV",
    "priceSource.type.estimate": "Estimacion",
    "priceSource.reliability.high": "Alta",
    "priceSource.reliability.medium": "Media",
    "priceSource.reliability.low": "Baja",
    "priceSource.reliability.unknown": "Desconocida",
    "costIndex.sourceType.official_index": "Indice oficial",
    "costIndex.sourceType.inflation_index": "Inflacion",
    "costIndex.sourceType.construction_cost_index": "Coste de construccion",
    "costIndex.sourceType.manual_index": "Manual",
    "costIndex.family.labor": "Mano de obra",
    "costIndex.family.material": "Materiales",
    "costIndex.family.equipment": "Equipo",
    "costIndex.family.energy": "Energia",
    "costIndex.family.transport": "Transporte",
    "costIndex.family.total_construction": "Construccion total",
    "costIndex.family.steel": "Acero",
    "costIndex.family.cement": "Cemento",
    "costIndex.family.concrete": "Hormigon / concreto",
    "costIndex.family.timber": "Madera",
    "costIndex.family.fuel": "Combustible",
    "costIndex.family.other": "Otro",
    "costIndex.sources.title": "Fuentes de indices",
    "costIndex.sources.desc": "Registre fuentes manuales u oficiales sin conectar busquedas automaticas.",
    "costIndex.sourceNamePlaceholder": "INE, INE ES, fuente interna...",
    "costIndex.publisher": "Publicador",
    "costIndex.monthly.title": "Indice mensual",
    "costIndex.monthly.desc": "Registre valores base y objetivo por familia de coste.",
    "costIndex.source": "Fuente",
    "costIndex.selectSource": "Seleccionar fuente",
    "costIndex.family": "Familia",
    "costIndex.basePeriod": "Periodo base",
    "costIndex.basePeriodPlaceholder": "ej: 2020=100",
    "costIndex.saveIndex": "Guardar indice",
    "costIndex.importCsv": "Importar CSV",
    "costIndex.run.title": "Ejecutar actualizacion empirica",
    "costIndex.run.desc": "Crea estimaciones en una tabla dedicada. No cambia observaciones, presupuestos ni PDFs.",
    "costIndex.targetYear": "Ano objetivo",
    "costIndex.targetMonth": "Mes objetivo",
    "costIndex.mode": "Modo",
    "costIndex.mode.dry": "Simular",
    "costIndex.mode.real": "Crear estimaciones",
    "costIndex.runAdjustment": "Ejecutar ajuste",
    "costIndex.registeredSources": "Fuentes registradas",
    "costIndex.previousRuns": "Runs anteriores",
    "costIndex.recentIndices": "Indices recientes",
    "costIndex.empty.sources": "Aun no hay fuentes de indices.",
    "costIndex.empty.runs": "Aun no hay ejecuciones.",
    "costIndex.empty.indices": "Aun no hay indices mensuales.",
    "costIndex.adjustedLine": "{adjusted}/{processed} ajustados. Fallos: {failed}.",
    "costIndex.summary.simulation": "Resumen de simulacion",
    "costIndex.summary.execution": "Resumen de ejecucion",
    "costIndex.summaryLine": "{adjusted} ajustados, {alreadyExists} ya existentes, {failed} fallidos, {processed} procesados.",
    "costIndex.toast.sourceCreated": "Fuente de indice creada",
    "costIndex.toast.indexCreated": "Indice mensual creado",
    "costIndex.toast.indicesImported": "Indices importados",
    "costIndex.toast.rowsLoaded": "{count} filas cargadas.",
    "costIndex.toast.simulationDone": "Simulacion completada",
    "costIndex.toast.updateDone": "Actualizacion completada",
    "costIndex.toast.localSimulation": "{summary} Edge Function no disponible; se uso simulacion local.",
    "costIndex.error.createSource": "No se pudo crear la fuente.",
    "costIndex.error.createIndex": "No se pudo crear el indice.",
    "costIndex.error.importCsv": "No se pudo importar el CSV.",
    "costIndex.error.runAdjustment": "No se pudo ejecutar el ajuste.",
    "costIndex.error.emptyCsv": "CSV sin filas validas. Use cabeceras: index_family,period_year,period_month,index_value.",
    "costIndex.error.estimatesNeedEdgeFunction": "La creacion de estimaciones requiere la Edge Function cost-adjust-prices.",
    "dashboard.duplicate.action": "Duplicar",
    "dashboard.duplicate.suffix": "(copia)",
    "dashboard.duplicate.createdTitle": "Presupuesto duplicado",
    "dashboard.duplicate.createdDescription": "Se ha creado una nueva copia en borrador.",
    "dashboard.list.actions": "Acciones del presupuesto",
    "dashboard.empty.title": "Empiece con su primer presupuesto técnico",
    "dashboard.empty.description":
      "Configure la empresa, cree el primer presupuesto y prepare la base para PDFs, mediciones, certificaciones y análisis técnico.",
    "dashboard.empty.settings": "Configurar empresa",
    "dashboard.empty.newBudget": "Crear primer presupuesto",
    "dashboard.empty.noBudgetsTitle": "Sin presupuestos todavía",
    "dashboard.empty.noBudgetsDescription":
      "Empiece por el presupuesto técnico o prepare primero la empresa, la base de costes y los archivos BIM/IFC. Estos pasos ayudan a generar documentos más claros y trazables.",
    "dashboard.empty.reviewPlan": "Ver límites del plan",
    "dashboard.empty.settingsDescription": "Datos comerciales para PDFs y documentos.",
    "dashboard.empty.ifcTitle": "Importar BIM/IFC",
    "dashboard.empty.ifcDescription": "Preparar archivos y mapeos técnicos.",
    "dashboard.empty.costDatabaseTitle": "Base de costes",
    "dashboard.empty.costDatabaseDescription": "Organizar recursos y composiciones reutilizables.",
    "dashboard.deleteDialog.title": "Eliminar presupuesto?",
    "dashboard.deleteDialog.description": "Esta accion no se puede deshacer.",
    "dashboard.deleteBlocked.title": "No se puede eliminar este presupuesto",
    "dashboard.deleteBlocked.description": "Los presupuestos enviados o aprobados no se pueden eliminar.",
    "dashboard.deleted": "Presupuesto eliminado",
    "ifcImport.compareDialog.title": "Comparar con el modelo anterior?",
    "ifcImport.compareDialog.description": "Este presupuesto ya tiene un modelo IFC asociado. Puede comparar el nuevo modelo con la version anterior antes de terminar la revision BIM.",
    "ifcImport.compareDialog.skip": "Continuar sin comparar",
    "ifcImport.compareDialog.confirm": "Comparar modelos",
    "ifcImport.compareGenerated": "Comparacion IFC generada",
    "dashboard.cockpit.eyebrow": "Panel operativo",
    "dashboard.painel.title": "Visión general",
    "dashboard.cockpit.title": "Organice presupuestos, documentos y próximos pasos",
    "dashboard.cockpit.description":
      "Una vista rápida para que los equipos de ingeniería sigan propuestas, versiones y capacidad comercial.",
    "dashboard.cockpit.portfolio": "Presupuestos",
    "dashboard.next.budget": "Siguiente presupuesto",
    "dashboard.next.blocked": "Revisar límite del plan",
    "dashboard.next.ready": "Listo para crear",
    "dashboard.next.status": "Cuenta",
    "dashboard.next.company": "Acceso",
    "dashboard.next.admin": "Administración activa",
    "dashboard.next.member": "Espacio de miembro",
    "dashboard.attention.eyebrow": "Atención necesaria",
    "dashboard.attention.title": "Próximos pasos",
    "dashboard.attention.clear": "Sin acciones críticas",
    "dashboard.attention.clearDescription": "La operación está lista para nuevos presupuestos y seguimiento comercial.",
    "dashboard.attention.companyTitle": "Completar identidad de empresa",
    "dashboard.attention.companyDescription": "Complete los datos comerciales antes de enviar propuestas reales.",
    "dashboard.attention.draftsTitle": "Borradores por terminar",
    "dashboard.attention.draftsDescription": "presupuestos aún necesitan revisión antes del envío.",
    "dashboard.attention.sentTitle": "Propuestas enviadas",
    "dashboard.attention.sentDescription": "presupuestos esperan seguimiento comercial.",
    "dashboard.attention.limitTitle": "Capacidad del plan alcanzada",
    "dashboard.attention.invitesTitle": "Invitaciones pendientes",
    "dashboard.attention.invitesDescription": "invitaciones esperan aceptación.",
    "dashboard.attention.viewDrafts": "Ver borradores",
    "dashboard.attention.viewSent": "Ver enviados",
    "dashboard.attention.manageTeam": "Gestionar equipo",
    "dashboard.summary.loading": "Cargando resumen del panel",
    "dashboard.summary.activeBudgets": "Presupuestos activos",
    "dashboard.summary.totalSuffix": "en total",
    "dashboard.summary.readyToExport": "Listos para exportar",
    "dashboard.summary.approvedBudgets": "Presupuestos aprobados",
    "dashboard.summary.noneApproved": "Ningún aprobado todavía",
    "dashboard.summary.needsAction": "Acción necesaria",
    "dashboard.summary.draftsOrSent": "Borradores o enviados",
    "dashboard.summary.costDatabase": "Base de Costes",
    "dashboard.summary.compositionAbbrev": "comp.",
    "dashboard.summary.resourcesSuffix": "recursos",
    "dashboard.summary.latestTotal": "Último total",
    "dashboard.summary.latestCalculation": "Del último cálculo",
    "identification.clientName": "Cliente",
    "identification.clientNamePlaceholder": "Nombre del cliente o entidad",
    "settings.adminOnly": "Solo los administradores pueden cambiar la configuración de la empresa.",
    "settings.adminOnlyHint":
      "Esta configuración afecta a documentos comerciales. Pida a un administrador que la cambie.",
    "settings.section.admin.eyebrow": "Administración",
    "settings.section.admin.title": "Plan, equipo y control",
    "settings.section.admin.description":
      "Gestione acceso, límites comerciales y señales de confianza de la organización.",
    "settings.section.company.eyebrow": "Identidad comercial",
    "settings.section.company.title": "Empresa y documentos",
    "settings.section.company.description":
      "Información usada en propuestas, PDFs y material para clientes.",
    "wizard.editBudget": "Editar presupuesto",
    "wizard.updated": "Presupuesto actualizado",
    "dashboard.version.createdTitle": "Nueva versión creada",
    "dashboard.version.createdDescriptionSuffix": "disponible en el historial.",
    "dashboard.version.new": "Nueva versión",
    "dashboard.version.history": "Historial de versiones",
    "dashboard.version.singular": "versión",
    "dashboard.version.plural": "versiones",
    "dashboard.version.fallbackBudgetName": "Presupuesto",
    "dashboard.version.current": "versión actual",
    "dashboard.version.createdFrom": "creada a partir de",
    "dashboard.version.open": "Abrir",
    "dashboard.version.version": "Versión",
    "dashboard.version.baseCost": "Coste base",
    "dashboard.version.snapshotNote":
      "Snapshot preservado para futura comparación y exportación PDF por versión.",
    "dashboard.version.create": "Crear nueva versión",
    "commerce.planTitle": "Plan y uso",
    "commerce.planDescription": "Estado comercial de la empresa y límites actuales de la cuenta.",
    "commerce.plan.trialLabel": "Gratuito",
    "commerce.status.trial": "gratuito",
    "commerce.status.active": "activo",
    "commerce.status.past_due": "pago pendiente",
    "commerce.status.canceled": "cancelado",
    "commerce.providerReady": "Cuenta conectada a un proveedor de facturación.",
    "commerce.providerPending": "La activación del plan Business la gestiona el equipo de Orzio.",
    "commerce.contactSales": "Activar Business",
    "commerce.upgradeCta": "Actualizar plan",
    "commerce.manageSubscription": "Gestionar suscripción",
    "commerce.currentPlan": "Plan actual",
    "commerce.planSku.trial": "Trial",
    "commerce.planSku.budget_starter": "Budget Starter",
    "commerce.planSku.budget_pro": "Budget Pro",
    "commerce.planSku.budget_business": "Budget Business",
    "commerce.planSku.takeoff_pro": "Takeoff Pro",
    "commerce.planSku.takeoff_team": "Takeoff Team",
    "commerce.productFamily.budget": "Budget",
    "commerce.productFamily.takeoff": "Takeoff",
    "commerce.trialBannerTitle": "Periodo de prueba activo",
    "commerce.trialBannerDescription":
      "Su organización está usando actualmente los límites del plan de prueba para este producto.",
    "commerce.trialEndsAt": "Fin de la prueba",
    "commerce.currentPeriodEndsAt": "Fin del período actual",
    "commerce.cancelAtPeriodEnd": "Cancelación programada al final del período",
    "commerce.planUnavailableTitle": "Detalles del plan no disponibles",
    "commerce.planUnavailableDescription":
      "Todavía no pudimos cargar el estado de facturación de esta organización.",
    "commerce.errorLoadingPlan": "No fue posible actualizar el estado de facturación",
    "commerce.noCustomer": "Todavía no existe una suscripción activa para gestionar.",
    "commerce.upgradePromptTitle": "Desbloquee más capacidad",
    "commerce.upgradePromptDescription":
      "Revise el plan actual para ampliar límites, gestionar la facturación y desbloquear más capacidad.",
    "commerce.checkoutSuccessTitle": "Suscripción activada",
    "commerce.checkoutSuccessDescription": "Gracias. El plan Business está activo y los límites han sido actualizados.",
    "commerce.checkoutCanceledTitle": "Pago cancelado",
    "commerce.checkoutCanceledDescription": "No se realizó ningún cargo. Puede intentarlo cuando quiera.",
    "commerce.reviewPlan": "Revisar plan",
    "commerce.upgradeRequired": "Upgrade necesario",
    "commerce.upgrade.budgetLimit":
      "Ha alcanzado el límite de presupuestos activos del plan actual.",
    "commerce.upgrade.versionLimit":
      "Ha alcanzado el límite de versiones por presupuesto del plan actual.",
    "commerce.upgrade.exportLimit":
      "Ha alcanzado el límite mensual de exportaciones PDF del plan actual.",
    "commerce.upgrade.moduleRequired":
      "Este tipo de presupuesto no esta incluido en el plan actual.",
    "commerce.enabledModules": "Módulos incluídos",
    "commerce.module.projects": "Presupuestos de proyectos",
    "commerce.module.works": "Presupuestos de obras",
    "commerce.activeBudgets": "Presupuestos activos",
    "commerce.members": "Miembros",
    "commerce.exportsThisMonth": "Exportaciones este mes",
    "commerce.aiCredits": "Créditos IA este mes",
    "commerce.unlimited": "ilimitado",
    "commerce.planUsageHelp": "Los límites se aplican a nivel de organización según el plan actual.",
    "commerce.blockedBudgetHelp": "Se alcanzó el límite de presupuestos activos. Revise la capacidad del plan antes de crear más presupuestos.",
    "commerce.trialReady": "Plan gratuito",
    "commerce.businessReady": "Business activo",
    "commerce.exportBlockedTitle": "Exportación bloqueada por el plan",
    "team.title": "Equipo",
    "team.description": "Gestione el acceso interno con invitaciones preparadas para el onboarding.",
    "team.adminOnly": "Solo los administradores pueden gestionar el equipo.",
    "team.invite": "Invitar",
    "team.inviteEmailLabel": "Email de invitación",
    "team.inviteRoleLabel": "Rol de invitación",
    "team.memberRoleLabel": "Rol del miembro",
    "team.inviteEmailPlaceholder": "compañero@empresa.es",
    "team.inviteCreated": "Invitación creada",
    "team.inviteProviderReady": "La invitación quedó preparada. El envío por email podrá activarse cuando el proveedor esté conectado.",
    "team.inviteEmailSent": "Email de invitación enviado.",
    "team.inviteEmailPending": "Invitación creada. El envío de email aún no está configurado.",
    "team.inviteEmailFailed": "Invitación creada, pero falló el envío de email. Copie el enlace manualmente.",
    "team.memberLimitReached": "Se alcanzó el límite de miembros del plan actual. Revise el plan antes de invitar a más personas.",
    "team.roleUpdated": "Rol actualizado",
    "team.memberRemoved": "Miembro eliminado",
    "team.inviteRevoked": "Invitación revocada",
    "team.members": "Miembros",
    "team.noMembers": "Aún no hay otros miembros en esta organización.",
    "team.pendingInvites": "Invitaciones pendientes",
    "team.noPendingInvites": "Sin invitaciones pendientes.",
    "team.inviteReference": "Referencia segura",
    "team.invitePrepared": "Lista para envío",
    "team.inviteAcceptanceReady": "Link de aceptación preparado",
    "team.copyInviteLink": "Copiar link",
    "team.inviteLinkCopied": "Link de invitación copiado",
    "team.revoke": "Revocar",
    "team.remove": "Eliminar",
    "team.confirmRemoveTitle": "¿Eliminar miembro?",
    "team.confirmRemoveDescription": "Este usuario perderá acceso a la organización. Podrá volver a ser invitado más adelante.",
    "team.confirmRevokeTitle": "¿Revocar invitación?",
    "team.confirmRevokeDescription": "Esta invitación pendiente dejará de poder utilizarse.",
    "team.confirmAction": "Confirmar",
    "team.permissions": "Permisos",
    "team.subaccessPermissions": "Permisos del subacceso",
    "team.subaccessPlanRequiredTitle": "Los subaccesos requieren un plan de pago",
    "team.subaccessPlanRequiredDescription":
      "Actualice al plan Business para invitar y gestionar subaccesos de su organización. Sus presupuestos y datos seguirán accesibles.",
    "activity.title": "Actividad reciente",
    "activity.description": "Señal rápida de acciones críticas registradas para soporte y auditoría.",
    "activity.empty": "Aún no hay actividad crítica registrada.",
    "activity.systemActor": "System",
    "team.role.member": "Miembro",
    "team.role.admin": "Admin",
    "invite.title": "Aceptar invitación",
    "invite.description": "Confirme el acceso para entrar en la organización.",
    "invite.organizationFallback": "Organización invitante",
    "invite.accept": "Aceptar invitación",
    "invite.acceptedTitle": "Invitación aceptada",
    "invite.acceptedDescription": "El acceso a la organización fue confirmado de forma segura.",
    "invite.acceptFailed": "No se pudo aceptar la invitación.",
    "invite.goDashboard": "Ir al panel",
    "invite.invalidTitle": "Invitación no disponible",
    "invite.invalidDescription": "Esta invitación no se puede usar. Pida una nueva invitación al administrador.",
    "invite.signInRequired": "Entre con el email invitado para aceptar este acceso.",
    "invite.signIn": "Entrar para aceptar",
    "invite.supportHint": "Si el acceso falla, pida al administrador que confirme el email invitado, el estado de la invitación y la validez del link.",
    "invite.status.invalid": "El link no corresponde a una invitación válida.",
    "invite.status.revoked": "Esta invitación fue revocada.",
    "invite.status.expired": "Esta invitación expiró.",
    "invite.status.accepted": "Esta invitación ya fue aceptada.",
    "invite.status.pending": "Esta invitación está lista para aceptación.",
    "execution.open": "Ejecución y medición",
    "execution.backToDashboard": "Volver al panel",
    "execution.eyebrow": "Ejecución 4D y certificados",
    "execution.title": "Ejecución y medición",
    "execution.subtitle": "Gestionar plan de ejecuci\u00f3n, mediciones de obra y certificados preparados desde el presupuesto aprobado.",
    "execution.generatePlan": "Generar plan de ejecucion",
    "execution.refreshPlan": "Actualizar plan",
    "execution.planGenerated": "Plan preparado",
    "execution.tasksPrepared": "tareas listas para seguimiento",
    "execution.tasks": "Tareas",
    "execution.tasksHelper": "Items operativos ligados al presupuesto",
    "execution.inProgress": "En curso",
    "execution.inProgressHelper": "Tareas con progreso activo",
    "execution.completed": "Completadas",
    "execution.completedHelper": "Tareas marcadas como completas",
    "execution.autos": "Certificados",
    "execution.autosHelper": "Lineas preparadas para certificado",
    "execution.emptyTitle": "A\u00fan no existe plan de ejecuci\u00f3n",
    "execution.emptyDescription": "Genere la primera estructura operativa desde los items reales de este presupuesto.",
    "execution.plan": "Plan",
    "execution.measurements": "Mediciones",
    "execution.taskRegister": "Registro de tareas",
    "execution.taskRegisterDescription": "Acompane fases, cantidades planeadas, estados y progreso.",
    "execution.phase": "Fase",
    "execution.task": "Tarea",
    "execution.planned": "Planeado",
    "execution.status": "Estado",
    "execution.progress": "Progreso",
    "execution.progressPercentHint": "Introduzca un valor entre 0 y 100%.",
    "execution.editTask": "Actualizar tarea",
    "execution.editTaskDescription": "Editar solo campos operativos seguros en esta primera version.",
    "execution.plannedStart": "Início planeado",
    "execution.plannedEnd": "Fin planeado",
    "execution.actualStart": "Início real",
    "execution.actualEnd": "Fin real",
    "execution.notes": "Notas",
    "execution.saveTask": "Guardar tarea",
    "execution.taskSaved": "Tarea actualizada",
    "execution.selectTask": "Seleccione una tarea para editar.",
    "execution.dependencies": "Dependências",
    "execution.dependenciesDescription": "Visibilidad preparada para enlaces de planificación y futuro timeline/Gantt.",
    "execution.dependenciesReady": "dependencias registradas",
    "execution.dependenciesEmpty": "A\u00fan no hay dependencias registradas. La estructura est\u00e1 lista para evolucionar.",
    "execution.measurementEntry": "Entrada de medición",
    "execution.measurementEntryDescription": "Registre cantidades medidas por tarea manteniendo historico auditable.",
    "execution.previous": "Anterior",
    "execution.remaining": "Restante",
    "execution.current": "Actual",
    "execution.measurementCurrentHint": "Cantidad de esta medicion. Sugerencia restante:",
    "execution.measurementQuantityRequired": "Indique una cantidad medida superior a cero.",
    "execution.measuredAt": "Fecha de medición",
    "execution.recordMeasurement": "Registrar medición",
    "execution.measurementRecorded": "Medicion registrada",
    "execution.accumulated": "Acumulado",
    "execution.measurementHistory": "Hist\u00f3rico de mediciones",
    "execution.approvedMeasurements": "mediciones aprobadas",
    "execution.measurementsEmpty": "A\u00fan no hay mediciones registradas para este presupuesto.",
    "execution.value": "Valor",
    "execution.unlinkedItem": "Item sin enlace",
    "execution.autoWorkflow": "Certificado de medición",
    "execution.autoWorkflowDescription": "Prepare un certificado desde mediciones aprobadas en el per\u00edodo seleccionado.",
    "execution.periodStart": "Inicio del período",
    "execution.periodEnd": "Fin del período",
    "execution.generateAuto": "Preparar certificado",
    "execution.autoPrepared": "Certificado preparado",
    "execution.lines": "líneas",
    "execution.futurePdf": "El certificado queda estructurado para revisi\u00f3n interna. La renderizaci\u00f3n PDF formal puede conectarse a esta estructura despu\u00e9s.",
    "execution.noAutos": "Aún no hay certificados preparados para este presupuesto.",
    "execution.autoNoLines": "Este certificado no tiene l\u00edneas elegibles. Apruebe mediciones en el per\u00edodo antes de generar otra vez.",
    "execution.statusUpdated": "Estado de medición actualizado",
    "execution.certificateStatusUpdated": "Estado del certificado actualizado",
    "execution.certified": "Certificada",
    "execution.submitReview": "Enviar a revision",
    "execution.approve": "Aprobar",
    "execution.reject": "Rechazar",
    "execution.void": "Anular",
    "execution.exportAutoPdf": "Exportar PDF",
    "execution.pdfPrepared": "PDF preparado",
    "execution.pdfVoidedBlocked": "Certificados anulados no pueden renderizarse.",
    "execution.popupBlocked": "No se pudo abrir la ventana de PDF. Autorice pop-ups para este sitio.",
    "execution.pdfLastRendered": "Último PDF",
    "execution.pdfNotRendered": "PDF aun no renderizado",
    // ── Cost Database Import ───────────────────────────────────────────────────
    "execution.autoProfileLead": "El modelo del certificado controla el pais, idioma, fiscalidad y firmas usadas en la vista previa y en la exportacion PDF.",
    "execution.autoProfileTitle": "Modelo del certificado",
    "execution.autoProfileDescription": "Elige el perfil operativo antes de revisar o exportar el documento final.",
    "execution.autoProfileCountry": "Pais del modelo",
    "execution.autoProfileContractType": "Tipo de contrato",
    "execution.autoProfileLanguage": "Idioma",
    "execution.autoProfileFinancialTitle": "Campos financieros",
    "execution.autoProfileTaxEnabled": "Activar IVA",
    "execution.autoProfileTaxRate": "Tasa de IVA",
    "execution.autoProfileRetentionEnabled": "Activar retencion",
    "execution.autoProfileRetentionRate": "Porcentaje de retencion",
    "execution.autoProfileSignaturesTitle": "Firmas",
    "execution.autoProfileSignature.contractor": "Incluir firma del contratista",
    "execution.autoProfileSignature.supervisor": "Incluir firma de la direccion / fiscalizacion",
    "execution.autoProfileSignature.owner": "Incluir firma de la propiedad",
    "execution.autoProfileLegalTitle": "Aviso operativo",
    "execution.autoProfileLegalDescription": "Este perfil es una configuracion operativa configurable de Orzio y no sustituye la validacion legal o contractual.",
    "execution.autoProfileCountryFields": "Campos especificos del pais",
    "execution.autoProfileCountryFieldsEmpty": "Este perfil no agrega campos operativos especificos del pais.",
    "execution.autoProfilePreviewTitle": "Vista previa",
    "execution.autoProfilePreviewDescription": "El documento inferior se actualiza inmediatamente con el modelo seleccionado.",
    "execution.autoProfilePreviewFrameTitle": "Vista previa del certificado de medicion",
    "execution.autoProfilePreviewEmpty": "Genera un certificado para activar la vista previa del PDF profesional.",
    "execution.autoProfileContract.private": "Privado",
    "execution.autoProfileContract.public": "Publico",
    "execution.autoProfileContract.internal": "Interno / revision piloto",
    "execution.autoProfileLanguageOption.pt": "Portugues",
    "execution.autoProfileLanguageOption.en": "Ingles",
    "execution.autoProfileLanguageOption.es": "Espanol",
    "execution.autoProfileLanguageOption.fr": "Frances",
    "execution.autoProfileCountryOption.PT": "Portugal",
    "execution.autoProfileCountryOption.ES": "Espana",
    "execution.autoProfileCountryOption.FR": "Francia",
    "execution.autoProfileCountryOption.DE": "Alemania",
    "execution.autoProfileCountryOption.UK": "Reino Unido",
    "execution.autoProfileCountryOption.IT": "Italia",
    "execution.autoProfileCountryOption.BE": "Belgica",
    "execution.autoProfileCountryOption.NL": "Paises Bajos",
    "import.upload.noFile": "Ningún fichero seleccionado",
    "import.upload.invalidFile.title": "Fichero inválido",
    "import.upload.tooLarge.title": "Fichero demasiado grande",
    "import.upload.bc3.invalidFile": "Seleccione un fichero .bc3",
    "import.upload.bc3.tooLarge": "Seleccione un fichero BC3 de hasta {limit}.",
    "import.upload.xlsx.invalidFile": "Seleccione un fichero .xlsx o .xls",
    "import.upload.xlsx.tooLarge": "Seleccione un fichero XLSX de hasta {limit}.",
    "import.upload.json.invalidFile": "Seleccione un fichero .json",
    "import.upload.json.tooLarge": "Seleccione un fichero JSON de hasta {limit}.",
    "import.upload.json.invalidJson.title": "JSON inválido",
    "import.upload.json.invalidJson.desc": "El fichero no es JSON válido. Compruebe la sintaxis e inténtelo de nuevo.",
    "import.upload.json.invalidFormat.title": "Formato inválido",
    "import.upload.json.invalidFormat.desc": "El JSON debe ser un array de elementos o un objeto con la propiedad \"items\" (array).",
    "import.upload.json.emptyItems.title": "Fichero sin elementos",
    "import.upload.json.emptyItems.desc": "El array \"items\" está vacío. Añada al menos un elemento antes de importar.",
    "import.upload.json.readError.title": "Error al leer fichero",
    "import.upload.json.readError.desc": "No se pudo leer el contenido del fichero JSON.",
    "import.upload.countryRequired": "País obligatorio",
    "import.upload.dateRequired": "Fecha de referencia obligatoria",
    "import.upload.bc3.started": "Importación iniciada",
    "import.upload.bc3.error": "Error en la importación",
    "import.upload.xlsx.started": "Importación XLSX iniciada",
    "import.upload.xlsx.error": "Error en la importación XLSX",
    "import.upload.json.started": "Importación JSON iniciada",
    "import.upload.json.error": "Error en la importación JSON",
    "import.form.sourceFile.bc3": "Fichero BC3 *",
    "import.form.sourceFile.xlsx": "Fichero XLSX *",
    "import.form.sourceFile.json": "Fichero JSON *",
    "import.form.sourceName": "Nombre de la fuente",
    "import.form.country": "País *",
    "import.form.countryOptional": "País",
    "import.form.region": "Región",
    "import.form.referenceDate": "Fecha de referencia *",
    "import.form.referenceDateOptional": "Fecha de referencia",
    "import.form.dataTier": "Tipo de dato *",
    "import.form.dataTierOptional": "Tipo de dato",
    "import.form.sheetName": "Nombre de la hoja",
    "import.action.importing": "Importando...",
    "import.action.importBC3": "Importar BC3",
    "import.action.importXLSX": "Importar XLSX",
    "import.action.importJSON": "Importar JSON del scraper",
    "import.action.downloadTemplate": "Descargar plantilla JSON",
    "import.action.downloadSample": "Descargar muestra PT/ES",
    "import.action.sampleDisclaimer": "La muestra PT/ES es solo para pruebas y demostración.",
    "import.action.normalize": "Normalizar",
    "import.action.review": "Revisión",
    "import.action.health": "Salud",
    "import.action.viewRows": "Ver filas",
    "import.action.close": "Cerrar",
    "import.action.refresh": "Actualizar",
    "import.normalize.done": "Normalización completada",
    "import.normalize.error": "Error en la normalización",
    "import.card.bc3.title": "Importar fichero BC3",
    "import.card.bc3.desc": "Suba un fichero FIEBDC-3 (.bc3) y complete los metadatos de la fuente. Los datos quedan en staging para revisión.",
    "import.card.xlsx.title": "Importar fichero XLSX",
    "import.card.xlsx.desc": "Suba una base de costes en Excel (.xlsx). El parser detecta automáticamente las columnas de código, descripción, unidad y precio.",
    "import.card.json.title": "Importar JSON del scraper",
    "import.card.json.desc": "Suba un JSON producido por un scraper externo. Las filas quedan en staging para normalización y revisión.",
    "import.card.jobs.title": "Importaciones",
    "import.card.jobs.emptyState": "Aún no hay importaciones. Seleccione un fichero .bc3, .xlsx o .json arriba para comenzar.",
    "import.disclaimer.rawData.title": "Datos brutos",
    "import.disclaimer.rawData.desc": "Los datos importados aún no han sido normalizados, validados ni vinculados al presupuesto. Esta fase es solo para inspección.",
    "import.disclaimer.history.title": "Referencia histórica",
    "import.disclaimer.history.desc": "Los precios importados son referencias históricas de una fuente externa y no deben tratarse como precio final de mercado.",
    "import.disclaimer.normalize.title": "Normalización",
    "import.disclaimer.normalize.desc": "La normalización crea sugerencias y conflictos para revisión. Ningún elemento se aprueba automáticamente ni se inserta en las tablas canónicas.",
    "import.jobs.file": "Fichero",
    "import.jobs.format": "Formato",
    "import.jobs.country": "País",
    "import.jobs.region": "Región",
    "import.jobs.refDate": "Fecha ref.",
    "import.jobs.type": "Tipo",
    "import.jobs.health": "Salud",
    "import.jobs.rows": "Filas",
    "import.jobs.mapped": "Mapeadas",
    "import.jobs.conflicts": "Conflictos",
    "import.jobs.createdAt": "Creado el",
    "import.jobs.actions": "Acciones",
    "import.rawRows.title": "Filas brutas",
    "import.rawRows.desc": "Muestra de filas de cost_import_raw_rows. Datos aún no normalizados.",
    "import.rawRows.parserWarnings": "Avisos del parser",
    "import.rawRows.empty": "No se encontraron filas para este job.",
    "import.rawRows.header.type": "Tipo",
    "import.rawRows.header.code": "Código",
    "import.rawRows.header.description": "Descripción",
    "import.rawRows.header.unit": "Unidad",
    "import.rawRows.header.unitPrice": "Precio unit.",
    "import.rawRows.header.parent": "Padre",
    "import.rawRows.header.coef": "Coef.",
    "import.rawRows.header.status": "Estado",
    "import.rowType.chapter": "Capítulo",
    "import.rowType.composition": "Composición",
    "import.rowType.resource": "Recurso",
    "import.rowType.concept": "Concepto",
    "import.rowType.compositionItem": "Elem. comp.",
    "import.rowType.text": "Texto",
    "import.health.title": "Salud de la importación",
    "import.health.stats.rows": "Filas",
    "import.health.stats.mappings": "Mapeos",
    "import.health.stats.conflicts": "Conflictos",
    "import.health.stat.totalImported": "Total importadas",
    "import.health.stat.pending": "Pendientes",
    "import.health.stat.mapped": "Mapeadas",
    "import.health.stat.conflict": "Conflicto",
    "import.health.stat.skipped": "Ignoradas",
    "import.health.stat.failed": "Con errores",
    "import.health.stat.suggested": "Sugeridos",
    "import.health.stat.approved": "Aprobados",
    "import.health.stat.rejected": "Rechazados",
    "import.health.stat.openConflicts": "Abiertos",
    "import.health.stat.resolvedConflicts": "Resueltos",
    "import.health.stat.ignoredConflicts": "Ignorados",
    "import.health.preflight.title": "Preflight",
    "import.health.preflight.noApproved": "Apruebe mapeos en la pestaña Revisión para activar el preflight.",
    "import.health.preflight.simulating": "Simulando promoción…",
    "import.health.preflight.promotable": "Promocionables",
    "import.health.preflight.blocked": "Bloqueados",
    "import.health.preflight.alreadyPromoted": "Ya promovidos",
    "import.health.preflight.simNote": "Simulación. No se insertó nada. Use Revisión para promover.",
    "import.health.preflight.clear": "Limpiar",
    "import.health.preflight.check": "Verificar",
    "import.health.preflight.error": "Error. Inténtelo de nuevo.",
    "import.health.quality.title": "Avisos de calidad",
    "import.health.quality.noCountry": "La importación no tiene país de origen definido.",
    "import.health.quality.sampleNote": "Avisos de calidad basados en las primeras",
    "import.health.status.imported": "Importado",
    "import.health.status.normalized": "Normalizado",
    "import.health.status.pendingReview": "Revisión pendiente",
    "import.health.status.readyToPromote": "Listo para promover",
    "import.health.status.promoted": "Promovido",
    "import.health.status.problems": "Con problemas",
    "import.health.status.processing": "Procesando",
    "import.health.status.imported.desc": "Fichero subido. Esperando normalización.",
    "import.health.status.normalized.desc": "Filas analizadas. Sin mapeos generados.",
    "import.health.status.pendingReview.desc": "Mapeos y/o conflictos esperando revisión manual.",
    "import.health.status.readyToPromote.desc": "Mapeos aprobados listos para generar referencias de precio.",
    "import.health.status.promoted.desc": "Referencias de precio generadas con éxito.",
    "import.health.status.problems.desc": "Error en la importación o fallo de procesamiento.",
    "import.health.pagination.note": "Los contadores de salud reflejan la página actual — use la pestaña Revisión para navegar.",
    "import.review.card.title": "Revisión",
    "import.review.card.desc": "Revise los mapeos sugeridos y resuelva conflictos. No se produce ningún cambio en el presupuesto en esta fase.",
    "import.review.alert.approvalNote": "La aprobación solo confirma el mapeo. No se envía ningún precio al presupuesto en esta fase.",
    "import.review.alert.openConflicts": "Los conflictos deben revisarse manualmente antes de generar observaciones de precio.",
    "import.review.tab.mappings": "Mapeos",
    "import.review.tab.conflicts": "Conflictos",
    "import.review.mappings.header.code": "Código",
    "import.review.mappings.header.description": "Descripción",
    "import.review.mappings.header.unit": "Unidad",
    "import.review.mappings.header.normUnit": "Unidad norm.",
    "import.review.mappings.header.type": "Tipo",
    "import.review.mappings.header.conf": "Conf.",
    "import.review.mappings.header.trace": "Trazabilidad",
    "import.review.mappings.header.method": "Método",
    "import.review.mappings.header.status": "Estado",
    "import.review.mappings.header.actions": "Acciones",
    "import.review.mappings.loading": "Cargando mapeos…",
    "import.review.mappings.empty": "No se generaron mapeos para este job.",
    "import.review.mappings.noResults": "Sin resultados para los filtros aplicados.",
    "import.review.conflicts.header.type": "Tipo",
    "import.review.conflicts.header.severity": "Severidad",
    "import.review.conflicts.header.message": "Mensaje",
    "import.review.conflicts.header.status": "Estado",
    "import.review.conflicts.header.actions": "Acciones",
    "import.review.conflicts.loading": "Cargando conflictos…",
    "import.review.conflicts.empty": "No hay conflictos registrados para este job.",
    "import.review.conflicts.resolve": "Resolver",
    "import.review.conflicts.ignore": "Ignorar",
    "import.review.conflicts.selectCandidate": "Seleccione candidato…",
    "import.review.conflicts.noCandidates": "Sin candidatos automáticos",
    "import.review.conflicts.selectToResolve": "Seleccione un candidato para activar \"Resolver\"",
    "import.review.conflicts.candidateRequired.title": "Candidato obligatorio",
    "import.review.conflicts.candidateRequired.desc": "Seleccione un candidato antes de resolver el conflicto.",
    "import.review.conflicts.resolveError.title": "Error al resolver conflicto",
    "import.review.conflicts.ignoreError.title": "Error al ignorar conflicto",
    "import.review.conflicts.noResults": "Sin resultados para los filtros aplicados.",
    "import.filter.search.mappings": "Buscar código, descripción, fuente, unidad…",
    "import.filter.search.conflicts": "Buscar mensaje, fuente…",
    "import.filter.status": "Estado:",
    "import.filter.lowConf": "Conf. baja",
    "import.sort.description": "Descripción",
    "import.sort.price": "Precio",
    "import.sort.date": "Fecha",
    "import.sort.confidence": "Confianza",
    "import.sort.message": "Mensaje",
    "import.status.suggested": "Sugerido",
    "import.status.approved": "Aprobado",
    "import.status.rejected": "Rechazado",
    "import.status.open": "Abierto",
    "import.status.resolved": "Resuelto",
    "import.status.ignored": "Ignorado",
    "import.batch.executing": "Procesando acción en lote…",
    "import.batch.conflict.executing": "Procesando conflictos en lote…",
    "import.batch.approve": "Aprobar",
    "import.batch.reject": "Rechazar",
    "import.batch.resolve": "Resolver",
    "import.batch.ignore": "Ignorar",
    "import.batch.clear": "Limpiar",
    "import.batch.confirm": "Confirmar",
    "import.batch.cancel": "Cancelar",
    "import.batch.error.title": "Error en acción en lote",
    "import.batch.approve.partial": "Aprobación parcial",
    "import.batch.reject.partial": "Rechazo parcial",
    "import.batch.approve.done": "Aprobación completada",
    "import.batch.reject.done": "Rechazo completado",
    "import.batch.conflict.resolve.partial": "Resolución parcial",
    "import.batch.conflict.ignore.partial": "Ignorados parcialmente",
    "import.batch.conflict.resolve.done": "Conflictos resueltos",
    "import.batch.conflict.ignore.done": "Conflictos ignorados",
    "import.batch.conflict.resolve.blocked.title": "Resolución en lote bloqueada",
    "import.batch.conflict.resolve.blocked.desc": "Todos los conflictos seleccionados y visibles deben tener exactamente 1 candidato.",
    "import.pagination.page": "Página",
    "import.pagination.of": "de",
    "import.pagination.prev": "← Anterior",
    "import.pagination.next": "Siguiente →",
    "import.promote.check": "Verificar promoción",
    "import.promote.validating": "Validando mapeos aprobados…",
    "import.promote.preflight.done": "Preflight completado. No se insertó nada en price_observations.",
    "import.promote.approved.label": "aprobados",
    "import.promote.promotable.label": "promocionables",
    "import.promote.blocked.label": "bloqueados",
    "import.promote.alreadyPromoted.label": "ya promovidos",
    "import.promote.reasons": "Principales motivos:",
    "import.promote.button.valid": "Promover elementos válidos",
    "import.promote.button.promote": "Promover",
    "import.promote.cancel": "Cancelar",
    "import.promote.promoting": "Generando referencias de precio…",
    "import.promote.result.simulation": "Simulación completada",
    "import.promote.result.done": "Referencias generadas",
    "import.promote.result.close": "Cerrar",
    "import.promote.error.preflight": "Error en el preflight",
    "import.promote.error.generate": "Error al generar referencias",
    "import.promote.problem.missingDescription": "Descripción faltante",
    "import.promote.problem.missingUnit": "Unidad faltante",
    "import.promote.problem.invalidUnitPrice": "Precio inválido",
    "import.promote.problem.missingCountry": "País faltante",
    "import.promote.problem.invalidReferenceDate": "Fecha inválida",
    "import.promote.problem.invalidDataTier": "Tier inválido",
    "import.promote.problem.invalidConfidenceScore": "Confianza inválida",
    "import.promote.problem.alreadyPromoted": "Ya promovido",
    "import.trace.noMetadata": "Sin metadatos adicionales",
    "import.trace.rawData": "Datos brutos",
    "import.trace.openSource": "Abrir fuente",
    "import.trace.scraperWarning": "Precio importado de fuente externa. Validar antes de aprobar.",
    "import.trace.scraperTag": "scraper",
    "import.trace.importTag": "import",
    "import.summary.totalRows": "Total filas",
    "import.summary.mapped": "Mapeadas",
    "import.summary.conflicts": "Conflictos",
  },
};
